<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <!-- <b-breadcrumb :items="breadcrumbs"/>        -->
         <b-card>
            <div slot="header">
              <strong>  {{subtitle}}</strong>
              <div class="card-header-actions" >
                <router-link
        to="/addvehicleInfo"
      > <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="useradd()"  type="button"><i class="fa fa-plus"></i> Add New</button> </router-link>
             
                 <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
              </div>
            </div>
            <div id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <!-- <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
               <input type="hidden" name="chkEditVal" id="chkEditVal" value="0">
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-form-input type="text" name="first name" v-model="customer.deliveryagentfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('first name')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="last name">Last Name</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="last name" v-model="customer.deliveryagentlastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter Last Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('last name')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="addmobilenumber">Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="addmobilenumber" name="mobile number" maxlength="10" v-model="customer.deliveryagentmobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobile number')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.mobile number')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-1.mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="Password">Password</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="password" name="password" minlength="6" maxlength="14" v-model="customer.password" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.password') }" placeholder="Enter Password">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.password')" id="passwordtxt" class="help text-danger">{{ errors.first('form-1.password') }}
                      </code>                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="pincode">Vehicle Number</label>
                      <b-input-group class="mb-3">
                         <input class="input" type="hidden" name="pincode" id="deliveryagentpincodedev" maxlength="6" v-validate="'required|digits:6'" :class="{'input': true, 'text-danger': errors.has('form-1.pincode') }" placeholder="Enter Location ID">
                       
                        <b-form-input class="input" type="text" v-model="customer.vehicleno" name="vehicleno" id="vehicleno" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.vehicleno') }" placeholder="Enter Vehicle Number">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehicleno')" class="help text-danger">{{ errors.first('form-1.vehicleno') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">Status</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">User Type</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.usertype" name="usertype" >
                          <option value="0">--Select--</option>
                          <option value="3">Try & Buy</option>
                          <option value="4">3PL</option>


                        </b-form-select>
                        </b-input-group>
                      
                      </b-form-group>
                  </b-col>
                </b-row>
                <footer class="column has-text-right">
                <b-button variant="primary" size="md" type="submit">Save</b-button>
                </footer>
              </b-form> -->
            </div>

            <div id="search"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
<!--               <b-form @submit.prevent="searchonclick('form-4')" data-vv-scope="form-4">
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-validate="'alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-4.firstname') }" name="firstname" v-model="searchObj.deliveryagentfirstname" placeholder="Enter First Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('firstname')" ></i>
                      </span>
                      
                      <span style="width:240px" v-show="errors.has('form-4.firstname')" class="help text-danger">{{ errors.first('form-4.firstname') }}</span>                     
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Mobile Number</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" id="searchmobilenumber" maxlength="10" v-validate="'numeric|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-4.mobilenumber') }" name="mobilenumber" v-model="searchObj.deliveryagentmobilenumber" placeholder="Enter Mobile Number">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobilenumber')" ></i>
                      </span>
                       <span style="width:240px" v-show="errors.has('form-4.mobilenumber')" class="help text-danger">{{ errors.first('form-4.mobilenumber') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Delivery Allocation Location ID</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.DeliveryPincode') }" name="DeliveryPincode" v-model="searchDeliveyPincode" placeholder="Enter Delivery Allocation Location ID">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">                     
                      <span style="width:240px" v-show="errors.has('form-4.DeliveryPincode')" class="help text-danger">{{ errors.first('form-4.DeliveryPincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Pickup Allocation Location ID</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.PickupPincode') }" name="PickupPincode" v-model="pickuppincodes" placeholder="Enter Pickup Allocation Location ID">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span style="width:240px" v-show="errors.has('form-4.PickupPincode')" class="help text-danger">{{ errors.first('form-4.PickupPincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>  
                  <b-col sm="3">
                    <b-form-group>
                      <label >Delivery Agent Master Id</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.agentmasterid') }" name="agentmasterid" v-model="searchObj.deliveryagentmasterid" placeholder="Enter Delivery Agent Master Id">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                       <span style="width:240px" v-show="errors.has('form-4.agentmasterid')" class="help text-danger">{{ errors.first('form-4.agentmasterid') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >Status</label>
                      <b-input-group class="mb-3">
                       <b-form-select v-model="searchObj.statuscode" name="status">
                        <option value="">--Select--</option>
                        <option value="Live">Live</option>
                        <option value="Profile Pending">Profile Pending</option>
                        <option value="Verfication Pending">Verfication Pending</option>
                      </b-form-select>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                      </span>
                      <code v-show="errors.has('form-4.status')" id="statusmsg">{{ errors.first('form-1.status') }}
                      </code>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >IsActive</label>
                      <b-input-group class="mb-3">
                        <b-form-select v-model="searchObj.isactive" name="isactive">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                      </b-input-group>
                     
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >Delivery Agent Location ID</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.deliveryagentpincode') }" name="deliveryagentpincode" v-model="searchObj.deliveryagentpincode" placeholder="Enter Delivery Agent Location ID">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                     
                       <span style="width:240px" v-show="errors.has('form-4.deliveryagentpincode')" class="help text-danger">{{ errors.first('form-4.deliveryagentpincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                  <footer class="column has-text-right">
                  <b-button variant="primary" size="md" type="submit">Search</b-button>
                  </footer>
              </b-form> -->
            </div>          
             
              <b-row class="mb-4">
                <input type="hidden" name="isactiveId" id="isactiveId" value="">
                <input type="hidden" name="deliveryagentmasterId" id="deliveryagentmasterId" value="">
                  <b-col md="4" class="my-1">
                    <b-col md="12">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  </b-col>
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                      <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions">
                          <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                          <option :value="false">Asc</option> <option :value="true">Desc</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>             
                 <!--  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                      <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </b-col> -->            
              </b-row> 
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
              <b-col sm="12">   
              <div style="float: left;" v-if="this.totalRows > 0">
               <span class="badge badge-primary" >PR</span> Indicates Privilege Rider &nbsp;&nbsp;
             </div> 

              <div style="float: left;" v-if="this.totalRows > 0">
               <span ><i class="fa fa-mobile" aria-hidden="true" style="color:#20a8d8;font-size: 20px;" ></i></span> Indicates IVR Rider&nbsp;&nbsp;
             </div> 

              <div style="float: left;" v-if="this.totalRows > 0">
               <span class="badge " style="background-color:#ff793f;color:white;font-size: 9px;padding:2px;
padding-top: 4px;">SDD</span> Indicates SDD Rider&nbsp;&nbsp;
             </div> 
               <div style="float: left;" v-if="this.totalRows > 0">
               <span class="badge " style="background-color:#95afc0;color:white;font-size: 9px;padding:2px;
padding-top: 4px;">NDD</span> Indicates NDD Rider&nbsp;&nbsp;
             </div> 
             <div style="float: left;" v-if="this.totalRows > 0">
               <span class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding:2px;
padding-top: 4px;">RR</span> Indicates Relieving Rider&nbsp;&nbsp;
             </div> 
              <!-- Main table element -->
              
              <b-table show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template slot="deliveryallocationlocation" slot-scope="row">
                   <b-button size="sm" class="mr-1"  href=""  data-toggle="tooltip" title="Add Delivery Location ID Allocate" @click=" getlocations(); deliveryallocateModal(row.item); " > <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button> 
                </template> 

                   <template slot="ridername" slot-scope="row">
                <span class="badge badge-primary" v-if="row.item.privilege_rider == 1" >PR</span>&nbsp;
                  <span v-if="row.item.relieving_rider == 1" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding:2px;padding-top: 4px;"   >RR</span>
                  {{row.item.deliveryagentfirstname}}
                  <!-- {{row.item.sdd_ndd_type}} -->
                  <span v-if="row.item.ivr_rider == 1" ><i class="fa fa-mobile" aria-hidden="true" style="color:#20a8d8;font-size: 18px;" ></i>
                  &nbsp;</span>
                   <span class="badge " v-if="row.item.sdd_ndd_type == 'SDD' " style="font-size: 9px;padding:2px;background-color:#ff793f;color:white;padding-top: 4px;">SDD</span>
                    <span class="badge " v-if="row.item.sdd_ndd_type == 'NDD'" style="font-size: 9px;padding:2px;background-color:#95afc0;color:white;padding-top: 4px;">NDD</span>
                </template> 
                 <!-- <template slot="ridername" slot-scope="row">
                   {{row.item.deliveryagentfirstname}}
                <span v-if="row.item.is_dummy == 'Yes'" ><i class="fa fa-mobile" aria-hidden="true" style="color:#20a8d8;font-size: 18px;" ></i></span>
                 
                </template>  -->

                <template slot="pickupallocationlocation" slot-scope="row">
                   <b-button size="sm" class="mr-1" href="" data-toggle="tooltip" title="Add Pickup Location ID Allocate" @click="getlocations(row.item); PickupAllocateModal(row.item) ">
                  <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button> 
                </template>

                <template slot="isactive" slot-scope="row">
                  <span  @click="toggleInfoModal(row.item)" style="cursor:pointer;">
                  <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive ==='0'" > 
                    <span class="badge badge-danger">Inative</span>
                  </span>  
                  <span data-toggle="tooltip" title="Active" v-else >
                    <span class="badge badge-success">Active</span>
                  </span>
                  </span>
                </template>

                <template slot="actions" slot-scope="row">
                  <b-button size="sm" title="Change Password" @click="editAgentMasterModal(row.item)" class="mr-1">
                  <i class="fa fa-key" ></i>
                  </b-button>

                  <!-- Button for Editing Delivery Agent Info -->

                  <b-button size="sm" @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Delivery Agent Info class"  class="mr-1">
                    Edit
                  </b-button>

                  <!-- end -->

                <!--   <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                      View
                    </b-button> --> 
                     <b-button size="sm" class="mr-1" href="" data-toggle="tooltip" title="Dashbord" @click="deliveryDashbord(row.item, row.index, $event.target)"><i class="fa fa-mobile fa-2x" ></i>
                  </b-button>
                  <b-button size="sm" data-toggle="tooltip" title=" Rider Details" @click="rackbucketModal(row.item)" >
                   <i class="fa fa-shopping-basket" aria-hidden="true"></i>

                  </b-button>
                 <!--  <b-button size="sm"  data-toggle="tooltip" title=" Available Ivr Number" @click="availableivrmodal(row.item)"  >
                    <i class="fa fa-list-alt" aria-hidden="true"></i>
                  </b-button>  -->
                  <!-- <b-button size="sm" @click="row.toggleDetails">
                    {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                  </b-button>-->

                  <!-- Button for Delivery Agent Log History -->

                  <b-button size="sm" data-toggle="tooltip" title="Delivery Agent Log" @click="deliveryagentlogmodal(row.item)"  >
                    <i class=" fa fa-history" aria-hidden="true"></i>
                  </b-button>

                  <!-- end -->
                </template>

                 <template slot="totalallocationallowed" slot-scope="row">
                  <!-- {{row.toggleDetails}} -->
                  <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                  <span v-bind:id="'totalAllocationsAllowedClsapen_' + row.item.deliveryagentmasterid" >{{ row.item.totalallocationallowed ? row.item.totalallocationallowed : '0'}} </span>   <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button>
                 </template>

                  <template slot="row-details" slot-scope="row">
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <form @submit.prevent="addAllowedAllocations(row.item.deliveryagentmasterid)">       
                            <b-input-group >
                              <!-- Attach Left button -->
                               <b-form-input type="number"  min="0" @keyup="onBlur(row.item.deliveryagentmasterid)" v-bind:value="row.item.totalallocationallowed" v-bind:id="'totalAllocationsAllowedCls_' + row.item.deliveryagentmasterid" ></b-form-input>
                              <b-input-group-prepend>
                                <b-button type="submit"  variant="primary">
                                  Save <i class="fa fa-save"></i> 
                                </b-button>
                              </b-input-group-prepend>
                             
                            </b-input-group>  
                             <span style="display:none;" v-bind:id="'msg' + row.item.deliveryagentmasterid"></span>     
                          </form>
                        </b-col>
                         
                      </b-row>
                    </b-card>
                  </template>         
              </b-table>
            </b-col>
            
          <!--     <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>   -->    
            <!-- Info modal -->         
        </b-card>
      </b-col>
    </b-row>



      <b-modal size="md" :id="dashboardinfo.id" :title="dashboardinfo.title" ok-only @hide="resetdashboardinfo" >
       <input type="hidden" name="deliveryboyId" id="deliveryboyId" v-model="deliveryboyId" value="">
       <input type="hidden" name="deliveryboyName" id="deliveryboyName" v-model="deliveryboyName" value="">
       <!-- {{ dashboardinfo.data}} -->
        <b-row v-for="value in dashboardinfo.data" :key="value.title">     
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">{{ value.title}}</b-alert>

          </b-col> 
         
          <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data" :key="rowvalue.cnt">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix">
                <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                <div class="h5 text-primary mb-0 mt-2">{{ rowvalue.cnt }}</div>
                <div class="text-muted  font-weight-bold font-xs">{{ rowvalue.name | capitalize }}</div>
              </b-card-body>
              <div slot="footer" v-if="rowvalue.pageType!=='codcollectable' ">
                <b-link v-if="rowvalue.pageType!=='codcollected' && rowvalue.pageType!=='ofd' &&rowvalue.pageType!=='rofd' && rowvalue.pageType!=='reversepickup' && rowvalue.pageType!=='palletcnt' && rowvalue.pageType!=='intransit' && rowvalue.pageType!=='handoverpending'&& rowvalue.pageType!=='totaldelivered' && rowvalue.pageType!=='failedpickup'&& rowvalue.pageType!=='clientpickcancel' " class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="forwardpickup_reg_war(rowvalue, $event.target,'forwardpickup')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>

                <b-link v-if="rowvalue.pageType =='ofd'" class="font-weight-bold font-xs btn-block text-muted"  @click="localityOfd('ofd')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                <b-link v-if="rowvalue.pageType =='rofd'" class="font-weight-bold font-xs btn-block text-muted"  @click="localityRofd('rofd')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>

                <b-link v-if="rowvalue.pageType =='reversepickup'" class="font-weight-bold font-xs btn-block text-muted"  @click="localityReverse(rowvalue,'reversepickup')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                <b-link v-if=" rowvalue.pageType =='intransit'" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="transit_count( rowvalue, $event.target,'intransit')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                <b-link v-if=" rowvalue.pageType =='handoverpending'" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="handoverpending_count( rowvalue, $event.target,'NDR')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                <b-link v-if=" rowvalue.pageType =='totaldelivered'" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="totaldelivered_count( rowvalue, $event.target,'totaldelivered')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                 <b-link v-if=" rowvalue.pageType =='failedpickup'" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="failedpickup_count( rowvalue, $event.target,'failedpickup')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                 <b-link v-if=" rowvalue.pageType =='clientpickcancel'" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="clientpickcancel_count( rowvalue, $event.target,'clientpickcancel')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                <!-- for pallet shipment -->
                <b-link v-if="rowvalue.pageType =='palletcnt' " class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllPalletShipmentsListByStatus(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>

                <!-- <b-link v-if="rowvalue.pageType!=='codcollectable'&& rowvalue.pageType!=='forwardpickup' && rowvalue.pageType!=='reversepickup'
                && rowvalue.pageType!=='intransit' && rowvalue.pageType!=='totaldelivered'
               && rowvalue.pageType!=='totalrto'
                && rowvalue.pageType!=='handoverpending'
                 && rowvalue.pageType!=='codcollected'
                  && rowvalue.pageType!=='failedpickup'
                   && rowvalue.pageType!=='palletcnt'" class="font-weight-bold font-xs btn-block text-muted"  @click="listingDashbord()">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link> -->
                  <!--  <b-link v-if="rowvalue.pageType!=='codcollectable'&& rowvalue.pageType!=='forwardpickup' && rowvalue.pageType!=='reversepickup'
                && rowvalue.pageType!=='ofd' && rowvalue.pageType!=='totaldelivered'
               && rowvalue.pageType!=='totalrto'
                && rowvalue.pageType!=='handoverpending'
                 && rowvalue.pageType!=='codcollected'
                  && rowvalue.pageType!=='failedpickup'
                   && rowvalue.pageType!=='palletcnt'" class="font-weight-bold font-xs btn-block text-muted"  @click="transitlist()">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link> -->
              </div>
            </b-card>
          </b-col>   
        </b-row> 
       
        <b-row v-for="value in dashboardinfo3pl.data" :key="value.title">     
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">{{ value.title}}</b-alert>

          </b-col> 
         
          <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data" :key="rowvalue.cnt">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix">
                <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                <div class="h5 text-primary mb-0 mt-2">{{ rowvalue  ? rowvalue.cnt : 0 }}</div>
                <div class="text-muted  font-weight-bold font-xs">{{ rowvalue.name | capitalize }}</div>
              </b-card-body>
               <div slot="footer" >
                <b-link  class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllShipmentsListByStatus3PL(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div> 
            </b-card>
          </b-col>   
        </b-row> 


      </b-modal>   
      <!-- Nazafat Addition -->

       <b-modal size="md" v-model="showOfd"  title="OFD Location Listing" ok-only  >
         <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">OFD</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" v-for="listing in ofd_listing" :key="listing.locality_id">
            <b-card :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div style="border:1px solid #20a8d8;margin-top:10px;padding:5px;    width: 150px;;margin-left: 20px;">
                   <b-link  class="font-weight-bold font-xs btn-block text-muted" v-b-tooltip.hover title="OFD Listing" @click="ofd_count($event.target,listing.locality_id,'ofd')">
                      <div class="h5 text-primary mb-0 mt-2">{{listing.ofdshipment_count}}</div>
                <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div>
                   </b-link>
                 
                </div>
                <div  v-b-tooltip.hover title="Unique Shipment Count" style="border:1px solid #20a8d8;margin-top:10px;padding:5px;    width: 150px;;margin-left: 20px;">
                  <div class="h5 text-primary mb-0 mt-2">{{listing.uniquecustomer}}</div>
                <div class="text-muted  font-weight-bold font-xs">Unique Count</div>
                </div>
                  
                <div v-if="sddndd_type == 'NDD'">
                  <!-- When reverse_bookingpendingshipment_count is NOT null -->
                  <div
                    v-if="listing.reverse_bookingpendingshipment_count != null"
                    style="border:1px solid #20a8d8; margin-top:10px; padding:5px; width:150px; margin-left:20px;"
                  >
                    <b-link
                      v-b-tooltip.hover
                      title="Reverse Shipment Count"
                      @click="reversecountdetails(listing.locality_id)"
                      class="h5 text-primary mb-0 mt-2"
                    >
                      <div class="h5 text-primary mb-0 mt-2">
                        {{ listing.reverse_bookingpendingshipment_count }}
                      </div>
                      <div class="text-muted font-weight-bold font-xs">Reverse Count</div>
                    </b-link>
                  </div>
                
                  <!-- When reverse_bookingpendingshipment_count IS null -->
                  <div
                    v-else
                    style="border:1px solid #20a8d8; margin-top:10px; padding:5px; width:150px; margin-left:20px;"
                  >
                    <div class="h5 text-primary mb-0 mt-2">
                      {{ reversecount }}
                    </div>
                    <div class="text-muted font-weight-bold font-xs">Reverse Count</div>
                  </div>
                </div>
                
               <!--  <div  style="border:1px solid #20a8d8;margin-top:10px;padding:5px;    width: 150px;margin-left: 20px; ">
                 
                     <div v-model="reversecount" class="h5 text-primary mb-0 mt-2">{{reversecount}}</div>
                     <div class="text-muted  font-weight-bold font-xs">Reverse Count</div> 
                </div> -->
              </b-card-body>
             <!--  <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showlocalitydetails($event.target,listing.locality_id)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div> -->
            </b-card>
          </b-col> 



         </b-row>


       </b-modal>
       <b-modal size="md" v-model="showRofd"  title="ROFD Location Listing" ok-only  >
         <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">ROFD</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" v-for="listing in rofd_listing" :key="listing.locality_id">
            <b-card :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{listing.ofdshipment_count}}</div>
                <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div>
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="rofd_count(listing.locality_id,'rofd')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>


       </b-modal>

        <!-- reverse pickup model -->

           <b-modal size="md" v-model="showReverse"  title="Reverse Pickup Listing" ok-only  >
         <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Reverse Pickup</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" v-for="listing in reverse_listing" :key="listing.locality_id">
            <b-card :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{listing.reverseshipment_count}}</div>
                <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div>
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="reversepickupcount(listing.locality_id,$event.target,'reversepickup')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>


       </b-modal>
















      <!-- Nazafat Addition -->
       <!--  <b-modal size="md" v-model="showOfd" :id="ofdlistinginfo.id" title="OFD Location Listing" ok-only @hide="resetofdlistinginfo" > -->
     <!--   <input type="hidden" name="deliveryboyId" id="deliveryboyId"  value="">
       <input type="hidden" name="deliveryboyName" id="deliveryboyName"  value=""> -->
       <!-- {{ofdlistinginfo.data}} -->
        <!-- <b-row v-for="value in ofdlistinginfo.data">      -->
        <!--   <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary"></b-alert>

          </b-col>  -->
         <!-- {{value.data[0].name}} -->
         <!--  <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data">
            <b-card :no-body="true" footer-class="px-3 py-2"  > -->
              <!-- v-for="listing in ofd_listing" -->
              <!-- <b-card-body style="text-align:center;" class="p-3 clearfix" > -->
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3  v-for="listing in ofd_listing"float-left"></i> -->
                <!-- <div class="h5 text-primary mb-0 mt-2" >{{ rowvalue.cnt }}{{listing.ofdshipment_count}} -->
                 <!-- <div class="text-muted  font-weight-bold font-xs">Kolkata{listing.locality_name}} -->
                 <!-- </div></div> -->
               
             <!--  </b-card-body>
              <div slot="footer" v-if="rowvalue.pageType!=='codcollectable' ">
                <b-link v-if="" class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllShipmentsListByStatus(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col>   
        </b-row>  -->
        <!--  <b-row v-for="value in ofdlistinginfo3pl.data">     
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">{{ value.title}}</b-alert>

          </b-col> 
         
          <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data" >
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body style="text-align:center;"  class="p-3 clearfix">
                <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                <div class="h5 text-primary mb-0 mt-2">{{ rowvalue  ? rowvalue.cnt : 0 }}</div>
                <div class="text-muted  font-weight-bold font-xs">{{ rowvalue.name | capitalize }}</div>
              </b-card-body>
               <div slot="footer" >
                <b-link  class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllShipmentsListByStatus3PL(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div> 
            </b-card>
          </b-col>   
        </b-row> 
 -->
         
       <!-- </b-modal> -->
       <!--  <b-modal size="md" v-model="showtran"  title="Transit Listing" ok-only @hide="resetdashboardinfo" >
         
       </b-modal> -->
 <!-- Reverse Count Model -->
<b-modal size="lg" v-model="showReversecount"  title="Reverse Shipment Count" ok-only > 
 <!--  <template slot="modal-header" slot-scope="{ close }">
         <h5>Reverse Shipment Count</h5>
  </template> -->
  <!-- <template slot="default"slot-scope="{ hide }"> -->
     <div class="card" v-for="(reverse, key, index) in reversecountdetail" >
      <!-- {{reverse}} -->
      <div class="card-header">
                  <div>
                   <code>{{(key+1)}} </code><strong>Shipment Id: </strong>{{ reverse.shippingid }}
                      <div class="card-header-actions">
                        <b-badge variant="danger" class="mr-4">{{ reverse.deliverystatus }} </b-badge>                     
                      </div>
                  </div>
        </div>
      <div class="card-body">     
       <div class="row mb-4">  
        <div class="col sm-12-4">
           <div><strong>{{ reverse.pickuplocationname }}</strong></div>
            <div><strong>Address :</strong>{{ reverse.pickuplocationaddress }}</div>    <div><strong>Hub ID:</strong> {{ reverse.hub_id }}</div>
            <div><strong>Lat Long:</strong> {{ reverse.pickuplonglat }}</div> 
           <!--  <div><strong>Handovertohub:</strong> <code>{{ reverse.handovertohub }}</code></div> -->
            <div><strong>Pickup Type:</strong> <code>{{ reverse.pickuptype }}</code></div> 

        </div>
         <div class="col-sm-4">
                        <div><strong>Poc Name :</strong>{{ reverse.pocname }}</div>                       
                        <div><strong>Shipment Status :</strong>{{ reverse.shipmentstatus }}</div>
                       
                        <div><strong>Vendor Name:</strong> {{ reverse.vendor_name }}</div>
                         <div><strong>OrderFlow:</strong> {{ reverse.orderflow }}</div>
                          <div><strong>Modified Date:</strong> {{ reverse.lastmodifieddate }}</div>
                     </div> 

      </div>
    </div>
     </div>
  <!-- </template> -->

</b-modal>



      <!-- Nazafat Addition --> 
       <b-modal :id="consignmentPickUpPendingList.id" :title="consignmentPickUpPendingList.title" ok-only @hide="resetconsignmentPickUpPendingList" size="lg">  
<!-- <pre>{{ consignmentPickUpPendingList.data.length }}</pre> -->
            <div v-if="consignmentPickUpPendingList.data.length > 0">
            <div class="card" v-for="(shipmentlist, key, index) in consignmentPickUpPendingList.data">
               <div class="card-header">
                  <div>
                   <code>{{(key+1)}} </code><strong>Shipment Id: </strong>{{ shipmentlist.shippingid }}
                      <div class="card-header-actions">
                        <b-badge variant="success" class="mr-4">{{ shipmentlist.deliverystatus }} </b-badge>                     
                      </div>
                  </div>
               </div>
               <div class="card-body">
                  <div class="row mb-4">
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Pickup:</h4> -->
                        <div><strong>{{ shipmentlist.pickuplocationname }}</strong></div>
                        <div>{{ shipmentlist.pickuplocationaddress }}</div>
                        <div><strong>Type:</strong>{{ shipmentlist.pickuplocationtype }}</div>                   
                        <div><strong>Hub ID:</strong> {{ shipmentlist.pickuplocationmasterid }}</div>
                        <div><strong>Lat Long:</strong> {{ shipmentlist.pickuplonglat }}</div> 
                        <div><strong>Handovertohub:</strong> <code>{{ shipmentlist.handovertohub }}</code></div>
                        <div><strong>Pickup Type:</strong> <code>{{ shipmentlist.pickuptype }}</code></div>                   
                     </div>
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Delivery:</h4> -->
                        <div><strong>{{ shipmentlist.customername }}</strong></div>                       
                        <div>{{ shipmentlist.shipaddress1 }}</div>
                       
                        <div><strong>Phone:</strong> {{ shipmentlist.shipmobilenumber1 }}</div>
                         <div><strong>Lat Long:</strong> {{ shipmentlist.shiplonglat }}</div>
                     </div> 
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Shipment Info:</h4>                         -->
                        <div>
                          <strong>Shipment Id:</strong>{{ shipmentlist.shippingid }}</div>                       
                        <div><strong>Order Id:</strong> 
                          {{ shipmentlist.orderid }}
                        </div>
                        <div v-if='shipmentlist.ordertype'>
                          <strong>Order Type:</strong> 
                          {{ shipmentlist.ordertype }}
                        </div>
                        <div>
                          <strong>Shipment Status:</strong> 
                          <code>{{ shipmentlist.shipmentstatus }}</code>
                        </div>
                        <div>
                          <strong>Service Type:</strong> 
                          <code>{{ shipmentlist.servicetype }}</code>
                        </div>
                        <div>
                          <strong>Delivery Type:</strong> 
                         <code> {{ shipmentlist.deliverystatus }}</code>
                        </div>
                        
                        <div v-if='shipmentlist.deliveryedd'>
                          <strong>Delivery Date:</strong> 
                          {{ shipmentlist.deliveryedd }}
                        </div>
                        <div v-if='shipmentlist.ordervalue'>
                          <strong>Total:</strong> 
                          {{ shipmentlist.ordervalue }}
                        </div>
                     </div>                 
                  </div>
                  <div class="table-responsive-sm" v-if="shipmentlist.prddetails.length > 0">
                     <table class="table  b-table table-bordered b-table-stacked-md">
                        <thead>
                           <tr>
                              <th class="center">Product Id</th>
                              <th>Item</th>
                               <th class="center">HSN code</th>
                              <th class="center">Quantity</th>
                             
                              <th class="right">Price</th>                      
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="prddetails in shipmentlist.prddetails">
                              <td class="center">{{prddetails.productid}}</td>
                              <td class="left">{{prddetails.productname}}</td> 
                               <td class="left">{{prddetails.hsncode}}</td>    
                              <td class="center">{{prddetails.productquantity}}</td>
                              
                              <td class="right">{{prddetails.productvalue}}</td>
                             
                           </tr>                   
                        </tbody>
                     </table>
                  </div> 
                  <div class="row"> 
                    <div class="col-sm-5 col-lg-4">
                    </div>              
                    <div class="col-sm-7 col-lg-8">
                      <table class="table table-clear b-table table-bordered b-table-stacked-md">
                         <tbody>
                            <tr>
                               <td class="left"><strong>Shipping Id:</strong></td>
                               <td class="right">{{ shipmentlist.shippingid }}</td>
                            </tr>
                            <tr >
                               <td class="left"><strong>Order Id:</strong></td>
                               <td class="right">{{ shipmentlist.orderid }}</td>
                            </tr>
                            <tr v-if='shipmentlist.ordertype'>
                               <td class="left"><strong>Order Type:</strong></td>
                               <td class="right">{{ shipmentlist.ordertype }}</td>
                            </tr>
                            
                             <tr v-if='shipmentlist.shipmentstatus'>
                               <td class="left"><strong>Shipment Status:</strong></td>
                               <td class="right">{{ shipmentlist.shipmentstatus }}</td>
                            </tr>
                            <tr v-if='shipmentlist.deliveryedd'>
                               <td class="left"><strong>Delivery date:</strong></td>
                               <td class="right">{{ shipmentlist.deliveryedd }}</td>
                            </tr>
                            <tr v-if='shipmentlist.ordervalue'>
                               <td class="left"><strong>Total</strong></td>
                               <td class="right"><strong>{{ shipmentlist.ordervalue }}</strong></td>
                            </tr>
                         </tbody>
                      </table>                   
                    </div>
                  </div>                           
               </div>                    
            </div>        
          </div>
          <template slot="modal-footer" slot-scope="{ cancel }">
         <!--   <a href="#" onclick="javascript:window.print();" class="btn btn-sm btn-info float-right ml-1"><i class="fa fa-print"></i> Print</a>  -->
          </template>
      </b-modal>
      <!-- pallet shipmentlisting    v-for="listing in ofd_listing"-->
      <b-modal size="md" v-model="showPallet" title="Allocated Pallet Listing"  ok-only>
        <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Allocated Pallet</h5>
          </template> -->
           <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Allocated Pallet</b-alert>
          </b-col> 
       
          <b-col cols="12" sm="12" lg="12" v-for="listing in palletshipment" :key="listing.pallet_id">
            <b-card :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <!-- <div class="h5 text-primary mb-0 mt-2">{{listing.pallet_id}}</div> -->
                <div class="row sm-12">
                   <div class="col-sm-5">
              <strong>Pallet Zone</strong>
            </div>
             <div class="col-sm-1">:</div>
                
              <div class="col-sm-6 h5 text-primary"  v-for="listing in palletshipment" :key="listing.pallet_id">
               {{listing.pallet_title}}
             </div>
             </div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.pallet_title}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showpalletdetails($event.target,listing.pallet_id)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 
          </b-row>
        <!--  <div class="card-body">
           <div class="row sm-12">
            <div class="col-sm-5">
              <strong>Pallet ID</strong>
            </div>
             <div class="col-sm-1">:</div>
             <div class="col-sm-6"  v-for="listing in palletshipment">
               {{listing.pallet_id}}
             </div>
           </div>
           <br>
           <div class="row sm-12">
            <div class="col-sm-5">
              <strong>Pallet Zone</strong>
            </div>
             <div class="col-sm-1">:</div>
             <div class="col-sm-6"  v-for="listing in palletshipment">
               {{listing.pallet_title}}
             </div>
           </div>
         </div> -->



     
         
         <!-- <template slot="modal-footer" slot-scope="{ cancel }">
           <a href="#" onclick="javascript:window.print();" class="btn btn-sm btn-info float-right ml-1"><i class="fa fa-print"></i> Print</a> 
          </template> -->

       </b-modal>




      <b-modal  :id="allshipmentsbystatus.id" :title="allshipmentsbystatus.title" ok-only @hide="resetallshipmentsbystatus" size="lg">

          <div v-if="allshipmentsbystatus.data.length > 0">
            <div class="card" v-for="(shipmentlist, key, index) in allshipmentsbystatus.data">
               <div class="card-header">
                  <div>
                     <code>{{(key+1)}}] </code><strong v-b-tooltip.hover title="Pickuplocationname">{{ shipmentlist.pickuplocationname}}</strong>
                      <div class="card-header-actions">
                        <b-badge variant="success" class="mr-4">{{ shipmentlist.deliverystatus }}</b-badge>

                        <b-badge variant="primary" v-if="shipmentlist.deliverystatus=='Pickup'" class="p-3"  @click="getconsignmentPickUpPendingList(shipmentlist, $event.target)" style="cursor:pointer">Views </b-badge>

                      </div>
                  </div>
               </div>
               <div class="card-body">
                  <div class="row mb-4">
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Pickup:</h4> -->
                        <div><strong v-b-tooltip.hover title="Shipment Id">{{ shipmentlist.shippingid }}</strong></div>
                        <div>{{ shipmentlist.pickuplocationaddress }}</div>
                        <div><strong>Pickup Type:</strong> <code>{{ shipmentlist.pickuplocationtype }} </code></div>                   
                        <div><strong>Hub ID:</strong> {{ shipmentlist.pickuplocationmasterid }}</div>
                        <div><strong>Lat Long:</strong> {{ shipmentlist.pickuplocation }}</div>  

                                   
                     </div>
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Delivery:</h4> -->
                        <div><strong>{{ shipmentlist.customername }}</strong></div>                       
                        <div>{{ shipmentlist.shipaddress }}</div>
                       
                        <div><strong>Phone:</strong> {{ shipmentlist.shipmobilenumber }}</div>
                         <div><strong>Lat Long:</strong> {{ shipmentlist.deliverylocation }}</div>
                     </div> 
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Shipment Info:</h4>                         -->
                        <div>
                          <strong>Shipment Id:</strong>{{ shipmentlist.shippingid }}</div>                       
                        <div><strong>Order Id:</strong> 
                          {{ shipmentlist.orderid }}
                        </div>
                        <div>
                          <strong>Order Type:</strong> 
                          {{ shipmentlist.ordertype }}
                        </div>
                        
                         <div>
                          <strong>Shipment Status:</strong> 
                          <code>{{ shipmentlist.shipmentstatus }}</code>
                        </div>
                        <div>
                          <strong>Service Type:</strong> 
                          <code>{{ shipmentlist.servicetype }}</code>
                        </div>
                        <div>
                          <strong>Delivery Type:</strong> 
                         <code> {{ shipmentlist.deliverystatus }}</code>
                        </div>
                        <div>
                         <strong>Return to:</strong> 
                         <code> {{ shipmentlist.rtoto }}</code>
                        </div>
                        
                        <div>
                          <strong>Delivery date:</strong> 
                          {{ shipmentlist.deliveryedd }}
                        </div>
                        <div v-if="shipmentlist.ordervalue!='0' && shipmentlist.ordervalue!='0.0'">
                          <strong>Total:</strong> 
                          {{ shipmentlist.ordervalue }}
                        </div>
                     </div>                 
                  </div>
                  <!-- <div v-if="shipmentlist.deliverystatus!='Pickup'">
                    <div class="table-responsive-sm" v-if="shipmentlist.prddetails.length > 0"  >
                       <table class="table  b-table table-bordered b-table-stacked-md">
                          <thead>
                             <tr>
                                <th class="center">Product Id</th>
                                <th>Item</th>
                                 <th class="center">Hsncode</th>
                                <th class="center">Quantity</th>
                                
                                <th class="right">Price</th>                      
                             </tr>
                          </thead>
                          <tbody>
                             <tr v-for="prddetails in shipmentlist.prddetails">
                                <td class="center">{{prddetails.productid}}</td>
                                <td class="left">{{prddetails.productname}}</td>        <td class="left">{{prddetails.hsncode}}</td>                   
                                <td class="center">{{prddetails.productquantity}}</td>
                                 
                                <td class="right">{{prddetails.productvalue}}</td>
                               
                             </tr>                   
                          </tbody>
                       </table>
                    </div>                 
                  </div>  --> <!-- {{shipmentlist.shipmentstatus}}
                              {{shipmentlist.servicetype}} -->

                    <div v-if="shipmentlist.deliverystatus!='Pickup'">
                  <button class="btn btn-sm btn-primary mr-4 btn-pill" @click="product(shipmentlist.pickuplocationtype,shipmentlist.deliverystatus,shipmentlist.shipmentstatus,shipmentlist.shippingid,shipmentlist.deliveryagentmasterid,shipmentlist.servicetype); productModal = true"   type="button"> Show product Details</button>
                </div>                         
               </div>                    
            </div>        
          </div>
          <template slot="modal-footer" slot-scope="{ cancel }">
           <!-- <a href="#" onclick="javascript:window.print();" class="btn btn-sm btn-info float-right ml-1"><i class="fa fa-print"></i> Print</a>  -->
          </template>
     <!--  <pre>{{ allshipmentsbystatus.data }}</pre> -->
      </b-modal>
      <b-modal title="Product Details" v-model="productModal" @ok="productModal = false">
     <!--  <div v-if="shipmentlist.deliverystatus!='Pickup'">
                    <div class="table-responsive-sm" v-if="shipmentlist.prddetails.length > 0"  > -->
                       <table class="table  b-table table-bordered b-table-stacked-md">
                          <thead>
                             <tr>
                                <th class="center">Product Id</th>
                                <th>Item</th>
                                 <th class="center">Hsncode</th>
                                <th class="center">Quantity</th>
                                
                                <th class="right">Price</th>                      
                             </tr>
                          </thead>
                          <tbody>
                             <tr v-for="prddetails in prddetail">
                                <td class="center">{{prddetails.productid}}</td>
                                <td class="left">{{prddetails.productname}}</td>        <td class="left">{{prddetails.hsncode}}</td>                   
                                <td class="center">{{prddetails.productquantity}}</td>
                                 
                                <td class="right">{{prddetails.productvalue}}</td>
                               
                             </tr>                   
                          </tbody>
                       </table>
                    <!-- </div>                 
                  </div>   -->
    </b-modal>
      <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
      </b-modal>

      <!-- Modal to Edit delivery Agent Info -->

      <b-modal title="Update Delivery Agent Info" v-model="editAgentMaster" @ok="editAgentMaster = false" hide-footer>
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5>Update Delivery Agent Info</h5>
          </template> -->
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">

              <!--   <b-form-group
                  label="First Name"
                  :label-cols="3" >
                  <b-form-input type="text" name="firstname" v-model="customer.deliveryagentfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-5.first name') }"placeholder="Enter First Name">
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.firstname')" class="help text-danger">{{ errors.first('form-5.firstname') }}</span>                 
                </b-form-group> -->
                <!-- <b-form-group
                  label="Last Name"
                  :label-cols="3" >
                  <b-form-input class="input" type="text" name="lastname" v-model="customer.deliveryagentlastname"  v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-5.lastname') }" placeholder="Enter Last Name">
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.lastname')" class="help text-danger">{{ errors.first('form-5.lastname') }}</span>                 
                </b-form-group> -->
                <b-form-group
                  label="Vehicle Prefix"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" maxlength="1" v-model="customer.vehicleno_prefix" name="vehicleno_prefix"   v-validate="{  regex: /^[A-Z]*$/, max: 1, }"  :class="{'input': true, 'text-danger': errors.has('form-5.vehicleprefix') }" placeholder="Enter Vehicle Prefix">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.vehicleno_prefix')" class="help text-danger">{{ errors.first('form-5.vehicleno_prefix') }} Please enter Capital letter only</span>
                </b-form-group>
                <b-form-group
                  label="Vehicle Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.editvehicleno" name="vehicleno" maxlength="6" v-validate="'required|numeric'" :class="{'input': true, 'text-danger': errors.has('form-5.vehicleno') }" placeholder="Enter Vehicle Number">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.vehicleno')" class="help text-danger">{{ errors.first('form-5.vehicleno') }}</span>
                </b-form-group>
                 <b-form-group label="Vehicle Local" :label-cols="3">
                    <b-form-select v-model="customer.local" v-on:change="setcountry" name="local"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                     <option value="">--Select--</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </b-form-select>
                    <span style="width:100px" v-show="errors.has('form-5.local')" class="help text-danger">{{ errors.first('form-5.local') }}</span>
                  </b-form-group>
                <b-form-group
                  label="Vehicle Country"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.vehicle_country" name="vehicle_country"  v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-5.vehiclecountry') }" placeholder="Enter Vehicle Country">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.vehicle_country')" class="help text-danger">{{ errors.first('form-5.vehicle_country') }}</span>
                </b-form-group>
                 <b-form-group
                  label="Vehicle City"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.vehicle_city" name="vehicle_city"  v-validate="{ required: true, regex: /^[A-Za-z\s\-]+$/
 }" :class="{'input': true, 'text-danger': errors.has('form-5.vehiclecity') }" placeholder="Enter Vehicle City">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.vehicle_city')" class="help text-danger">{{ errors.first('form-5.vehicle_city') }}</span>
                </b-form-group>
                 <!--  <b-form-group label="Local" :label-cols="3">
                    <b-form-select v-model="customer.local" name="local"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-5.local') }">
                      
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </b-form-select>
                    <span style="width:100px" v-show="errors.has('form-5.local')" class="help text-danger">{{ errors.first('form-5.local') }}</span>
                  </b-form-group> -->
                 

                   <b-form-group
                  label="Mobile Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.mobile_no" name="mobile_no"  v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.mobile_no') }" placeholder="Enter Mobile Number ">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.mobile_no')" class="help text-danger">{{ errors.first('form-5.mobile_no') }}</span>
                </b-form-group>

                  <b-form-group
                  label="Alternate Mobile Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.altmobile_no" name="altmobile_no"  v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.altmobile_no') }" placeholder="Enter Mobile Number ">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.altmobile_no')" class="help text-danger">{{ errors.first('form-5.altmobile_no') }}</span>
                </b-form-group>

                <b-form-group
                  label="Driving License"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.driving_license" name="driving_license"   v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.driving_license') }"  placeholder="Enter Driving License">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.driving_license')" class="help text-danger">{{ errors.first('form-5.driving_license') }}</span>
                </b-form-group>
                <b-form-group
                  label="Driver Contracter Name"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.driver_contracter_name" name="driver_contracter_name"  v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-5.driver_contracter_name') }" placeholder="Enter Driver Contracter Name">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.driver_contracter_name')" class="help text-danger">{{ errors.first('form-5.driver_contracter_name') }}</span>
                </b-form-group>
                <b-form-group
                  label="Contracter Email ID"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.contracter_emailid" name="contracter_emailid"  v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-5.contracter_emailid') }" placeholder="Enter Contracter Email ID">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.contracter_emailid')" class="help text-danger">{{ errors.first('form-5.contracter_emailid') }}</span>
                </b-form-group>
                <b-form-group label="Is Dummy" :label-cols="3">
                    <b-form-select v-model="customer.is_dummy" name="is_dummy" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                     <option value="null">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </b-form-select>
                     <span style="width:100px" v-show="errors.has('form-5.is_dummy')" class="help text-danger">{{ errors.first('form-5.is_dummy') }}</span>
                  </b-form-group>


                      <b-form-group label="User Type" :label-cols="3">
                       
                        
                          <b-form-select v-model="customer.editusertype" name="editusertype"  @change="fmrider(customer.editusertype)"  :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                          <option value="0">Select</option>
                          <option value="3">Try & Buy</option>
                          <option value="4">First Mile</option>

                        </b-form-select>
                        <span style="width:100px" v-show="errors.has('form-5.editusertype')" class="help text-danger">{{ errors.first('form-5.editusertype') }}</span>
                       
                      </b-form-group>

                      <!-- <div v-if="customer.editusertype === '4'"> -->
                        
                      <div  v-if="display_value==true">
                       <b-form-group   label="FM Rider Type" :label-cols="3">
                       
                        
                          <b-form-select  v-model="customer.editfmridertype" name="editfmridertype"  :class="{'input': true, 'is-invalid': errors.has('form-5.editfmridertype') }">
                         <option value="">--Select--</option>
                          <option value="0">Normal FM Rider </option>
                          <option value="1">Relieving FM Rider</option>

                        </b-form-select>
                        <span style="width:100px" v-show="errors.has('form-5.editfmridertype')" class="help text-danger">{{ errors.first('form-5.editfmridertype') }}</span>
                       
                      </b-form-group>
                    </div>
                        <!-- </div> -->
                       <b-form-group label="Is Privilage Rider" :label-cols="3">
                       
                        <!-- {{customer.isprivilage}} -->
                          <b-form-select v-model="customer.isprivilage" name="isprivilage"  :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                          <option value="null">Select</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>

                        </b-form-select>
                        <span style="width:100px" v-show="errors.has('form-5.isprivilage')" class="help text-danger">{{ errors.first('form-5.isprivilage') }}</span>
                       
                      </b-form-group>
                    <b-form-group v-if="user_id === 124 || user_id === 61" label="Is IVR Rider" :label-cols="3">
                    <b-form-select v-model="customer.ivr_rider" name="ivr_rider" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                     <option value="null">Select</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </b-form-select>
                     <span style="width:100px" v-show="errors.has('form-5.ivr_rider')" class="help text-danger">{{ errors.first('form-5.ivr_rider') }}</span>
                  </b-form-group>
                   <b-form-group label="SDD/NDD Rider" :label-cols="3">
                    <b-form-select v-model="customer.is_sdd_ndd" name="is_sdd_ndd" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-5.is_sdd_ndd') }">
                    <option value="null">--Select--</option>
                    <option value="SDD">SDD</option>
                    <option value="NDD">NDD</option>
                    </b-form-select>
                     <span style="width:100px" v-show="errors.has('form-5.is_sdd_ndd')" class="help text-danger">{{ errors.first('form-5.is_sdd_ndd') }}</span>
                  </b-form-group>
                 
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 

      <!-- End -->


      <b-modal title="Confirmation Box" v-model="toggleInfo" size="md" @ok="toggleInfo = false">
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Confirmation Box</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <form v-on:submit.prevent="activateInActivateDeliveryAgent(value)">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <input type="hidden" v-model="customer.isactive" name="isactive" id="modalIsActiveChk">
                <span>Are you sure you want to change the status?</span>
              </section>
              <footer >
                <b-button variant="primary" size="sm" type="submit">Ok</b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
      <b-modal title="Delivery Allocation Location"  v-model="delivertLocationModal" size="md" @ok="delivertLocationModal = false" class="modal-info" ok-variant="info" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
        <h5>Delivery Allocation Location</h5>
        </template> -->
        <template slot="default" slot-scope="{ hide }">
           <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
              <b-form-group
                label="Select Locations"             
                :label-cols="3"
                >
                <b-form-select v-model="customer.deliverypincodestextarea" name="pincodes" multiple id="textareapincodes" required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id" v-for="(value, index) in locations" >
                      {{ value.locality_name }}
                      </option>
                </b-form-select>
                <span v-show="errors.has('form-2.pincodes')" id="pincodemsg" class="help text-danger">{{ errors.first('form-2.pincodes') }}</span>
              </b-form-group>
            
              <div slot="footer" class="text-right">
                <b-button type="submit" size="sm" class="mr-4" variant="primary">Allocate</b-button>
                <b-button size="sm" variant="danger"  @click="CloseDeliveryAllocateModal">
            Cancel
          </b-button>
           </div>
            </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger"  style="display:none" >
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>

          <!-- Modal for Delivery agent log history -->

         <b-modal  size="xl" title="Delivery Agent Log" v-model="showdeliveryagentlogmodal" @ok="showdeliveryagentlogmodal = false" hide-footer>
         <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Delivery Agent Log</h5>
          </template> -->
          <template slot="default" slot-scope="{ hide }"> 
              <b-form-group>
                <div  class='col-md-12' id="vendor_list_scroll">
                  <!-- {{items.sdd_ndd_type}} -->
                  <table id="table"  class="table table-bordered table-striped mb-0">
                    <thead>
                    
                    
                      <th id="th_style">Id</th>
                      <th id="th_style">First Name</th>
                      <th id="th_style">Last Name</th>
                      <th id="th_style">Contact Number</th>
                      <th id="th_style">Alternate Number</th>
                      <th id="th_style"> Actual Vehicle No</th>
                      <th id="th_style">Reference VehicleNo</th>
                      <th id="th_style">Status</th>
                      <th id="th_style">IS Local</th>
                      <th id="th_style">Is Relieving Rider</th>
                      <th id="th_style">Is Privilege Rider</th>
                       <th id="th_style">Is IVR Rider</th>
                      <th id="th_style">SDD/NDD Rider</th>
                      <th id="th_style">Vehicle City</th>
                      <th id="th_style">Vehicle Country</th>
                      <th id="th_style">Created By</th>
                      <th id="th_style">Created Date</th>
                      </thead>
                      <tbody v-if="logdetailslength>0">
                      <tr  v-for="items in logdetails">
                        <td>{{items.driverp2pId}}</td>
                        <td >{{items.driverFirstName}}</td>
                        <td >{{items.driverLastName}}</td>
                        <td>{{items.driverContactNumber}}</td>
                        <td>{{items.driverAlternateContactNumber}}</td>
                        <td>{{items.actualVehicleNo}}</td>
                        <td>{{items.referenceVehicleNo}}</td>
                      <!--   {{ row.item.isactive==1 ? 'Active':'In active' }} -->
                        <td>{{items.isActive == 'true' ? 'Active' :'InActive'}}</td>
                        <td>{{items.isLocal =='true' ? 'Yes' : 'No'}}</td>
                        <td>{{items.relieving_rider == '1' ? 'Yes' : 'No'}}</td>
                        <td>{{items.privilege_rider =='true' ? 'Yes' : 'No'}}</td>
                        <td>{{items.ivr_rider =='true' ? 'Yes' : 'No'}}</td>
                         <td>{{items.sdd_ndd_type}}</td>
                        <td>{{items.vehicleCity}}</td>
                        <td>{{items.vehicleCountry}}</td>
                        <td>{{items.createdBy}}</td>
                        <td>{{items.createdDate}}</td>

                      </tr>
                    </tbody>
                    <tbody v-if="logdetailslength==0">
                      <tr style="text-align: center;">No records Found</tr>
                    </tbody>
                  </table>
                </div>

              </b-form-group>
                <div slot="footer" class="text-right">
                 
                  <b-button  size="sm" variant="danger" @click="agentlogcancel()">cancel</b-button>
                </div>
              <!-- </b-form> -->
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
      </b-modal>
      <b-modal title="Pickup Allocation Location" v-model="pickupLocationModal" size="md" @ok="pickupLocationModal = false" hide-footer>
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5 >Pickup Allocation Location</h5>
          </template> -->

          <template slot="default" slot-scope="{ hide }">
            <b-form @submit.prevent="validateForm3('form-3')" data-vv-scope="form-3">
              
              <b-form-group
                label="Select Locations"             
                :label-cols="3"
                >
                 <b-form-select v-model="customer.pickuppincodestextarea" name="pickuppincodes" multiple required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id"  v-for="(value, index) in locations">
                      {{ value.locality_name }}
                      </option>                 
                  </b-form-select>
                <span v-show="errors.has('form-3.pickuppincodes')" id="pincodemsg1" class="help text-danger">{{ errors.first('form-3.pickuppincodes') }}</span>
              </b-form-group>
            
              <div slot="footer" class="text-right">
                <b-button type="submit" size="sm" class="mr-4" variant="primary">Allocate</b-button>
                <b-button size="sm" variant="danger" @click="pickcancel()" >
              Cancel
            </b-button>            
              </div>
            </b-form>
          
          </template>

          <template slot="modal-footer" slot-scope="{ cancel }">
            <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal>

          <b-modal title="Rack Bucket" v-model="showrackbucketdata" @ok="showrackbucketdata = false" hide-footer>
         <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Rack Bucket</h5>
          </template> -->
          <template slot="default" slot-scope="{ hide }">
             <!-- <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5" > -->
               
              <b-form-group>
                <div class="table-wrapper-scroll-y custom-scrollbar">

                  <table  class="table table-bordered table-striped mb-0">
                    <thead>
                    </thead>
                    <tbody v-if="vendorlength>0">
                      <tr>
                        <td class="racktd">Rider Name</td>
                        <td class="racktd">Zone Name</td>
                        <td class="racktd">Vendor Name</td>
                      </tr>

                      <tr v-for="data in vendordata">
                        <td >{{data.deliveryagentname}}</td>
                        <td>{{data.zone_name}}</td>
                        <td>{{data.vendor_name}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="vendorlength==0">
                      <tr>
                        <td class="racktd">Rider Name</td>
                        <td class="racktd">Zone Name</td>
                        <td class="racktd">Vendor Name</td>
                      </tr>

                      <tr>
                        <td colspan="3" style="text-align: center;">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              </b-form-group>
                <!-- <b-form-select v-model="customer.deliverypincodestextarea" name="pincodes" multiple id="textareapincodes" required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id" v-for="(value, index) in locations" >
                      {{ value.locality_name }}
                      </option>
                </b-form-select> -->
                 
                <div slot="footer" class="text-right">
                 
                  <b-button  size="sm" variant="danger" @click="rackBucketcancel()">cancel</b-button>
                </div>
              <!-- </b-form> -->
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
      </b-modal>

          <b-modal title="Show Available IVR Number List" v-model="showavailableivrmodal" @ok="showavailableivrmodal = false" >
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Available IVR Number</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <!-- <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5" > -->
               
              <b-form-group>
                <div class="table-wrapper-scroll-y custom-scrollbar">

                  <table  class="table table-bordered table-striped mb-0">
                    <thead >
                    </thead>
                    <tbody v-if="ivrdatalength>0">
                      <tr v-for="items in ivrdata">
                        <td >{{items.ivrnumber}}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="ivrdatalength==0">
                      <tr style="text-align: center;">No records Found</tr>
                    </tbody>
                  </table>
                </div>

              </b-form-group>
                <!-- <b-form-select v-model="customer.deliverypincodestextarea" name="pincodes" multiple id="textareapincodes" required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id" v-for="(value, index) in locations" >
                      {{ value.locality_name }}
                      </option>
                </b-form-select> -->
                 
                <div slot="footer" class="text-right">
                 
                  <b-button  size="sm" variant="danger" @click="ivrmodalcancel()">cancel</b-button>
                </div>
              <!-- </b-form> -->
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
      </b-modal>
      <b-modal  title="Change Password" size="md" v-model="editAgentMastertoggleInfo" @ok="editAgentMastertoggleInfo = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
        <h5>Change Password</h5>
        </template> -->
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                     <span style="color: red;">Strong Passowrd Rules:<br>

                    1)Your password must be between 6 to 30 character<br>
                    2)Password must contain at least one lowercase and uppercase character<br>
                    3)Password must contain at least one number<br>
                    4)Password must contain at least one special character <br>
                    </span>
                    <b-form-input class="input" type="text" name="password" minlength="6" maxlength="14" v-model="customer.deliveryagentpassword" v-validate="{ required: true, regex:/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/ }" :class="{'input': true, 'text-danger': errors.has('form-4.password') }"
                      placeholder="Enter password" />
                    <code v-show="errors.has('form-4.password')" class="help text-danger">{{ errors.first('form-4.password') }}</code>
                  </p>
                </div>
              </section>
              <footer class="text-right">
                <b-button size="sm" variant="primary" type="submit" class="mr-4">Update</b-button>
                 <b-button size="sm" variant="danger" @click="cancel()" >
            Cancel
          </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
       <b-modal size="md" title="Forward Pickup Count" v-model="forwardpickup_countmodel" @ok="forwardpickup_countmodel = false" hide-footer>
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Forward Pickup Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatus( $event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatus( $event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>

      </b-modal>
       <b-modal size="md" title="Reverse Pickup Count" v-model="reversepickup_countmodel" @ok="reversepickup_countmodel = false" hide-footer>
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Reverse Pickup Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showReversepickupdetails($event.target,'reversepickup',shipmentcount.regularshipmentcount,'0')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showReversepickupdetails($event.target,'reversepickup',shipmentcount.warrantyshipmentcount,'1')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>

      </b-modal>
      <b-modal size="md" title="OFD Count" v-model="ofd_model" @ok="ofd_model = false" hide-footer>
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">OFD Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showlocalitydetails($event.target,'ofd',shipmentcount.regularshipmentcount,'0')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showlocalitydetails($event.target,'ofd',shipmentcount.warrantyshipmentcount,'1')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>

      </b-modal>
      <b-modal size="md" title="ROFD Count" v-model="rofd_model" @ok="rofd_model = false" hide-footer>
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">ROFD Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showRofdlocalitydetails($event.target,'rofd',shipmentcount.regularshipmentcount,'0')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="showRofdlocalitydetails($event.target,'rofd',shipmentcount.warrantyshipmentcount,'1')">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>

      </b-modal>
      <b-modal size="md" title="INTransit Count" v-model="transit_count_model" @ok="transit_count_model = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Give Remark</h5>
          </template> -->
        <!--  <template slot="default" slot-scope="{ hide }"> -->
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">INTransit Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
       <!-- </template> -->

      </b-modal>
      <b-modal size="md" title="HandoverPending Count" v-model="handoverpending_count_model" @ok="handoverpending_count_model = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Give Remark</h5>
          </template> -->
        <!--  <template slot="default" slot-scope="{ hide }"> -->
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">HandoverPending Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
       <!-- </template> -->

      </b-modal>
      <b-modal size="md" title="Total Delivered Count" v-model="totaldelivered_count_model" @ok="totaldelivered_count_model = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Give Remark</h5>
          </template> -->
        <!--  <template slot="default" slot-scope="{ hide }"> -->
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Total Delivered Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
       <!-- </template> -->

      </b-modal>
      <b-modal size="md" title="Failed Pickup Count" v-model="failedpickup_count_model" @ok="failedpickup_count_model = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Give Remark</h5>
          </template> -->
        <!--  <template slot="default" slot-scope="{ hide }"> -->
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Failed Pickup Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
       <!-- </template> -->

      </b-modal>

      <b-modal size="md" title="Clientpickcancel Count" v-model="clientpickcancel_count_model" @ok="clientpickcancel_count_model = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
          <h5>Give Remark</h5>
          </template> -->
        <!--  <template slot="default" slot-scope="{ hide }"> -->
        <b-row>
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">Clientpickcancel Count</b-alert>

          </b-col> 
         
          <b-col cols="6" sm="6" lg="6" >
           <!--  <b-card  class="text-center"> 
          </b-card> -->
            <b-card header="Regular Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">
              {{shipmentcount.regularshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'0',shipmentcount.regularshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 

           <b-col cols="6" sm="6" lg="6" >
            <b-card header="Warranty Shipment" :no-body="true" footer-class="px-3 py-2" style="text-align:center">
              <b-card-body class="p-3 clearfix">
                <!-- <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i> -->
                <div class="h5 text-primary mb-0 mt-2">{{shipmentcount.warrantyshipmentcount}}</div>
               <!--  <div class="text-muted  font-weight-bold font-xs">{{listing.locality_name}}</div> -->
              </b-card-body>
              <div slot="footer">
                <b-link  class="font-weight-bold font-xs btn-block text-muted" @click="getAllShipmentsListByStatusfortransit($event.target,'1',shipmentcount.warrantyshipmentcount)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col> 



         </b-row>
       <!-- </template> -->

      </b-modal>

        <!--   <b-modal size="md" v-model="requisition_reject" @ok="requisition_reject = false" hide-footer>
          
         
      </b-modal> -->  
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
  data: function() {
    return {
      name: "deliveryagentmaster",
      isBusy: false,      
      pickupLocationModal: false,
      delivertLocationModal: false,
      subtitle:'Delivery Agent Info',
      data: [],
      ClientData: [],
      clients: [],
      searchDeliveyPincode: "",
      pickuppincodes: "",
      customer: {},
      // selected:'',
      seen: true,
      searchObj: {},
      clientsIds: [],
      clientResult:[],
      toggleInfo: false,
      deliveryallocatetoggleInfo: false,
      pickupallocatetoggleInfo: false,
      serviceableclientstoggleInfo: false,
      editAgentMastertoggleInfo: false,
      editAgentMaster:false,
      locations: [],
      value: [],
      pindata: [],
      bordered: true,
      items:[],
      searchResults:[],
      showdeliveryagentlogmodal: false,
      searchResults1:[],
      deliveryboyId:'',
      deliveryboyName:'',
      deliveryboyMb:'',
      productModal: false,
      customer:{
          deliverypincodestextarea:[],
          pickuppincodestextarea:[],
      },
      // fields: [
      //     { key: 'deliveryagentmasterid', label: 'Id', sortable: true, sortDirection: 'desc' },
      //     { key: 'ridername', label: 'First Name', sortable: true },
      //     { key: 'deliveryagentlastname', label: 'Last Name', sortable: true},
      //     { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},
      //     {key:  'vehicleno', label: 'Vehicle No', sortable: true},          
      //     { key: 'isactive', label: 'is Active', sortable: true},    
      //     { key: 'actions', label: 'Actions' },
      //     { key: 'deliveryallocationlocation', label: 'Delivery Allocation' },
      //     { key: 'pickupallocationlocation', label: 'Pickup Allocation' },
      //     { key: 'totalallocationallowed', label: 'Capacity'},
          
      //   ],
        ofd_listing:[],
        reversecount:0,
        rofd_listing:[],
        reverse_listing:[],
        palletshipment:[],
        values:[],
        items1:[],
        data1:[],
        showOfd:false,
        showRofd:false,
        showReverse:false,
        showPallet:false,
        showtran:false,
        totalRows: 0,
        currentPage: 1,
        showavailableivrmodal: false,
         ivrdata: [],
         showrackbucketdata:false,
         ivrdatalength: 0,
         vendorlength: 0,
         vendordata: [],
        //perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: true,
        sortDirection: 'desc',
        filter: null,
        selected_rider: 0,
        sddndd_type:'',
        prddetail:[],
        showReversecount:false,
        reversecountdetail:[],
        display_value:false,
        user_id:0,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        // Nazafat Addition
        logdetailslength:0,
         ofdlistinginfo:{
           id: 'ofdlisting-modal',
           title: '',
           content: '',
           data: ''
        },
        ofdlistinginfo3pl:{
           id: 'ofdlisting-modal',
           title: '',
           content: '',
           data: ''
        },
        // Nazafat Addition
        dashboardinfo:{
           id: 'dashboard-modal',
           title: '',
           content: '',
           data: ''
        },
          dashboardinfo3pl:{
           id: 'dashboard-modal',
           title: '',
           content: '',
           data: ''
        },
        allshipmentsbystatus:{
           id: 'shipments-list-modal',
           title: '',
           content: '',
           data: ''
        },
        consignmentPickUpPendingList:{
           id: 'pending-list-modal',
           title: '',
           content: '',
           data: ''
        },
        forwardpickup_countmodel:false,
        selected_cnt:0,
        selected_name:'',
        selected_pagetype:'',
        regularshipmentcount:'',
       shipmentcount:{
        regularshipmentcount:0,
       warrantyshipmentcount:0,
       },
       selected_locid:0,
       reversepickup_countmodel:false,
       ofd_model:false,
       rofd_model:false,
       transit_count_model:false,
       handoverpending_count_model:false,
       totaldelivered_count_model:false,
       failedpickup_count_model:false,
       clientpickcancel_count_model:false,
       selected_iswarranty:'',
    };
  },
  created: function() {
    // console.log("In Created Function");
    //document.getElementById("showheader").value = "1";
    //this.getlocations();
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
    this.user_id = userInfo.sysusermasterid;
    this.displaydata();

  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  mounted: function() {
    this.clients = [{ name: "a" }, { name: "b" }];
    //  var checkValidUser = auth.checkValidUser()
    //  if(checkValidUser){
    //    this.$router.push('dashboard')
    //  }
    //this.totalRows = this.items.length
    // this.fmrider();
  },
  methods: {
    fmrider:function(value){

      // alert(value);
      if(value=='3'){
        // alert("innnn");
        // document.getElementById('hidefmrider').style.display = "none";
        this.display_value=false;
      }
      else{
        // alert("out");
        this.display_value=true;
         // document.getElementById('hidefmrider').style.display = "block";
      }
    },
      ofdFun:function(){
        this.showOfd=true;
      },
      transitlist:function(){
        this.showtran=true;
      },
      reloadPage(){
      window.location.reload()
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
       resetofdlistinginfo(){
         this.ofdlistinginfo.title = ''
         this.ofdlistinginfo.content = ''
         this.ofdlistinginfo.data = ''
      },
      resetdashboardinfo(){
         this.dashboardinfo.title = ''
         this.dashboardinfo.content = ''
         this.dashboardinfo.data = ''
      },
      resetallshipmentsbystatus(){
         this.allshipmentsbystatus.title = ''
         this.allshipmentsbystatus.content = ''
         this.allshipmentsbystatus.data = ''
      },
      resetconsignmentPickUpPendingList(){
         this.consignmentPickUpPendingList.title = ''
         this.consignmentPickUpPendingList.content = ''
         this.consignmentPickUpPendingList.data = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    getlocations: function(value){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var deliveryagentmasterid1 = `${userInfo.deliveryagentmasterid}`;
     const passwObj = {
        // deliveryagentid: this.deliveryagentmasterid1,
        hub_id:`${userInfo.pickuplocationmasterid}`,
      };
    
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/locationlist`,passwObj)
        .then(result => {
          this.locations = result.body.returnvalue;
          console.log("HH",this.locations);
          this.getallocatedpincode();
          
        })
        .catch(ex => {
            console.log("error", ex);
          // alert(ex);
           // this.$fire({
           //        text: ex,
           //        type: "error",
           //        timer: 30000
           //      });
        });


    },
     product: function(type,status,value1,value2,value3,servicetype){
 // alert(status);
      if(type!="3PL")
      {
   
    // alert(value3);

   if(status=="INTransit" )
    {
      var shipstatus="intransit"
    }
      else if(status=="HandoverPending")
      {
        var shipstatus="handoverpending"
       
      }
      else if(status=="Delivered")
      {
        var shipstatus="totaldelivered"
       
      } 
       else if(status=="Failed Pickup")   
      {
        var shipstatus="failedpickup"
       
      }
     
   
      else if(status=="RTO")
      {
        var shipstatus="totalrto"
       
      }
  
      
      
      else{
        if(servicetype=="return")
        {
          var shipstatus="rofd"
        }
        else{
           var shipstatus=value1.toLowerCase()
        }
       

      }
         
    
     const passwObj = {
        deliveryagentmasterid: value3,
        shipmentstatus:shipstatus,
         shippingid:value2
      };
    
    
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getallshipmentslistbystatusdetails`,passwObj)
        .then(result => {
          this.prddetail = result.body.data.shipment_list[0].prddetails;
          // console.log("pr",this.prddetail);
          
          
        })
        .catch(ex => {
            console.log("error", ex);
          // alert(ex);
           // this.$fire({
           //        text: ex,
           //        type: "error",
           //        timer: 30000
           //      });
        });
}
else 
{
   const passwObj = {
        deliveryagentmasterid: value3,
        shipmentstatus:"3pl",
         shippingid:value2
      };
    
    
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getallshipmentslistbystatus3PLdetails`,passwObj)
        .then(result => {
          this.prddetail = result.body.data.shipment_list[0].prddetails;
          // console.log(this.prddetail);
          
          
        })
        .catch(ex => {
            console.log("error", ex);
          // alert(ex);
           // this.$fire({
           //        text: ex,
           //        type: "error",
           //        timer: 30000
           //      });
        });
}           

    },
    
    getallocatedpincode: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     
        const passwObj = {
        deliveryagentid: `${this.customer.deliveryagentmasterid}`,
       hub_id:`${userInfo.pickuplocationmasterid}`,
      };
      // return false;
    this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getdeliveryandpickuppincodes`,passwObj)
        .then(result => {
          
         var results=[];
            results =result.body.returnvalue[0].deliverypincodes;

           if(results!=null)
           {

         
            results.forEach((element) => { 
                      
            //console.log(element.deliverypincode);

             this.searchResults.push(element.deliverypincode);
            }); 
          }
         
          var results1=[];
            results1 =result.body.returnvalue[0].pickuppincodes;


         if(results1!=null)
           {
            results1.forEach((element) => { 
                      
            //console.log(element.pickuppincode);

             this.searchResults1.push(element.pickuppincode);
            });
          }
      
//console.log(this.searchResults1);
      // this.pindata = result.body;
      // console.log(this.pindata);
    
          
        })
        .catch(ex => {
            console.log("error", ex);
          // alert(ex);
           // this.$fire({
           //        text: ex,
           //        type: "error",
           //        timer: 30000
           //      });
        });
      },
    deliveryallocateModal: function(value) {

      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.deliverypincodes = value.deliverypincodes;
      this.customer.deliverypincodestextarea = this.searchResults;
      this.customer.deliveryagentpincode = value.deliveryagentpincode;
      this.customer.pickuppincodes = value.pickuppincodes;
      this.delivertLocationModal = !this.delivertLocationModal;
      // if (value.deliverypincodes) {
      //   var myObj = value.deliverypincodes;
      //   if (typeof myObj === "string") {
      //     myObj = JSON.parse(myObj);
      //   }
      //   if (myObj) {
      //     var objStr = [];
      //     for (var i = 0; i < myObj.length; i++) {
      //       objStr.push(myObj[i].deliverypincode);
      //     }
      //     this.customer.deliverypincodestextarea = objStr;
      //     console.log('deliverypincodestextarea',this.customer.deliverypincodestextarea);
      //     //document.getElementById("textareapincodes").value = objStr;
      //   }
      // }
    },
     PickupAllocateModal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.deliverypincodes = value.deliverypincodes;
       this.customer.pickuppincodestextarea = this.searchResults1;
      this.customer.deliveryagentpincode = value.deliveryagentpincode;
      this.customer.pickuppincodes = value.pickuppincodes;
      this.pickupallocatetoggleInfo = !this.pickupallocatetoggleInfo;
      this.pickupLocationModal = !this.pickupLocationModal;
      // if (value.pickuppincodes) {
      //   var myObj = value.pickuppincodes;
      //   if (this.isJson(value.pickuppincodes)) {
      //     myObj = JSON.parse(myObj);
      //   }
      //   if (myObj) {
      //     var objStr = [];
      //     for (var i = 0; i < myObj.length; i++) {
      //       objStr.push(myObj[i].pickuppincode);
      //     }
         
      //     console.log('pickuppincodestextarea',this.customer.pickuppincodestextarea);
      //     //document.getElementById("textareapincodes1").value = objStr;
      //   }
      // }
    },
    displaydata: function() {
     
      this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      };
      console.log('deliveryagentobj',deliveryagentobj);
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/deliveryagentmastergetall`,
          deliveryagentobj
        )
        .then(result => {
          if (result.body.length > 0) {
            this.isBusy = !this.isBusy
            this.data = result.body;
            // console.log('Data',this.data);
            this.items  = result.body;
             // console.log('item',this.items);
            this.totalRows = result.body.length
          } else {
            this.isBusy = !this.isBusy
            this.data = result.body;
            this.items  = result.body;
            this.totalRows = result.body.length
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
      // this.$http
      //   .post(`${CONSTANTS.MIGRATION_API_URL}/clientmasterget`)
      //   .then(result => {
      //     this.ClientData = result.body;
      //   })
      //   .catch(ex => {
      //     alert(ex);
      //   });
    },
    useradd: function() {
      this.customer = {};
      this.customer.usertype='0';
      this.customer.editfmridertype='';
      this.subtitle='Add vehicle info';
      this.errors.clear("form-1");
      var search1 = document.getElementById("search");
      search1.style.display = "none";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // document.getElementById("deliveryagentpincodedev").value = userInfo.pickuplocationpincode;
      // document.getElementById("deliveryagentpincodedev").disabled = true;
      // document.getElementById("chkEditVal").value = "0";
    },
    refresh:function() {
      this.subtitle='Delivery Agent info';
      var search1 = document.getElementById("search");
      search1.style.display = "none";
      this.seen = !this.seen;
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    search: function() {
      this.subtitle='Search Delivery Agent info';

      var search1 = document.getElementById("search");
      search1.style.display = "block";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    searchclear: function() {
      this.searchObj = {};
      this.searchDeliveyPincode = "";
      this.pickuppincodes = "";
      this.errors.clear("form-4");
      this.displaydata();
    },
      deliveryagentlogmodal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdeliveryagentlogdetails`,passwObj).then(result => {
             if (result.body.returnmsg=="Successful") {
              this.logdetails = result.body.returnvalue;
              console.log("hiiiii",this.logdetails);
               this.showdeliveryagentlogmodal = !this.showdeliveryagentlogmodal;
              // console.log("log Details", this.logdetails);
              this.logdetailslength =1;
              //this.isBusy = !this.isBusy

            }
            else{
            this.logdetails = []
            this.logdetails= "No Record Found";
             this.showdeliveryagentlogmodal = !this.showdeliveryagentlogmodal;
            this.logdetailslength =0;
           
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
         
    },
    searchonclick: function(scope) {
      this.$validator.validateAll(scope).then(result => {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (!result) {
          var myObj = JSON.parse(JSON.stringify(this.searchObj));
          if (this.searchDeliveyPincode !== "") {
            myObj.deliverypincodes = this.searchDeliveyPincode;
          }
          if (this.pickuppincodes !== "") {
            myObj.pickuppincodes = this.pickuppincodes;
          }
          if (userInfo.pickuplocationpincode !== "") {
            myObj.deliveryagentpincode = `${userInfo.pickuplocationpincode}`;
          }
          this.$http
            .post(
              `${
                CONSTANTS.MIGRATION_API_URL
              }/deliveryagentmastergetall`,
              myObj
            )
            .then(result => {
              if (
                result.body.returnmsg &&
                result.body.returnmsg === "UnSuccessful"
              ) {
                this.data = [];
                alert("Result Not Found");
                //  this.$fire({
                //   text: "Result not found",
                //   type: "error",
                //   timer: 30000
                // });
              } else if (result.body.length === 0) {
                this.data = [];
                alert("Result Not Found");
                // this.$fire({
                //   text: "Result not found",
                //   type: "error",
                //   timer: 30000
                // });
              } else if (result.body.returnmsg === "error") {
                this.data = [];
                alert(result.body.returnvalue);
                // this.$alert(result.body.returnvalue);
              } else {
                this.data = result.body;
              }
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          console.log("error");
        }
      });
    },
    ivrmodalcancel: function() {
      this.customer = {};
     this.showavailableivrmodal = !this.showavailableivrmodal;
    },
    rackBucketcancel: function() {
      this.customer = {};
     this.showrackbucketdata = !this.showrackbucketdata;
    },
    availableivrmodal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      var passwObj = {
        agentid: `${this.customer.deliveryagentmasterid}`
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getavailableivrnumber`,passwObj).then(result => {
             if (result.body.returnmsg=="Successful") {
              this.ivrdata = result.body.returnvalue;
              this.ivrdatalength =1;
              //this.isBusy = !this.isBusy
            }
            else{
            this.ivrdata = []
            this.ivrdata= "No Record Found";
            his.ivrdatalength =0;
           
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
          this.showavailableivrmodal = !this.showavailableivrmodal;
       // this.customer.deliveryagentmasterid = value.deliveryagentmasterid;      
       // this.availableivrmodal = !this.availableivrmodal;
    },
    rackbucketModal: function(value) {
     this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
     var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdeliveryagentassignedvendorlist`,passwObj).then(result => {
          
             if (result.body.returnmsg=="Successful") {
               
              this.vendordata = result.body.returnvalue;
             this.vendorlength = 1;
              //this.isBusy = !this.isBusy
             // this.showrackbucketdata = !this.showrackbucketdata;
            }
            else{
            this.ivrdata = []
            this.ivrdata= "No Record Found";
           this.vendorlength = 0;
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
       // this.customer.deliveryagentmasterid = value.deliveryagentmasterid;   
        //this.isBusy = !this.isBusy;   
        this.showrackbucketdata = !this.showrackbucketdata;
      // }
    },
    onBlur: function(deliveryagentmasterid) {
      document.getElementById("msg" + deliveryagentmasterid).style.color = "";
      document.getElementById("msg" + deliveryagentmasterid).innerHTML = "";
      document.getElementById("msg" + deliveryagentmasterid).style.display =
        "none";
    },
    chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("addmobilenumber").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addAgentInfo();
        }
      });
    },
    validateForm2(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.searchResults=[];
         
          this.AllocateDeliveryPincodes();
        }
      });
    },
    AllocateDeliveryPincodes: function() {
     
      // return false;
      var result = [];
       
        var deliverypin = this.customer.deliverypincodestextarea;
         
          //console.log("29april"+deliverypin)
      
       var codes = deliverypin;
        
       // var a = codes.indexOf(`${this.customer.deliverypincodestextarea}`);
       
//console.log("value of a"+a);
       

        // if (a === -1) {
        //   codes.push(`${this.customer.deliveryagentpincode}`);
        // }
        
        for (var q = 0; q < codes.length; q++) {
         
         var allpincode = codes[q].toString();
         console.log("allpincode",allpincode);
         // return false;
          

         
           
            const pincodeObj = {
              deliverypincode: allpincode
            };
            
            result.push(pincodeObj);
         
        
        }
// console.log("value of a"+JSON.stringify(result)); 
        
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var deliveryObj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
          pincodes: JSON.stringify(result),
          lastmodifiedby: `${userInfo.sysemailid}`
        };
        if (typeof this.customer.deliveryagentmasterid !== "undefined") {

          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/allocatedeliverypincodes`, deliveryObj)
            .then(result => {
              this.customer.deliverypincodestextarea = [];
              Utils.notify("Added Successfully", "success");
               // this.$fire({
               //    text: "Added Successfully",
               //    type: "success",
               //    timer: 30000
               //  });
             
               //this.displaydata();
              this.delivertLocationModal = !this
                .delivertLocationModal;
                this.customer = {};
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          alert("Please Allocate Delivery Agent Master Id");
            // this.$fire({
            //       text: "Please Allocate Delivery Agent Master Id",
            //       type: "warning",
            //       timer: 30000
            //     });
        }
      
      
      //}
    },
    
    CloseDeliveryAllocateModal: function() {
      this.customer = {};
      this.delivertLocationModal = !this.delivertLocationModal;
    },
    clearDeliveryPincode: function() {
      //document.getElementById("textareapincodes").value = "";
      this.customer.deliverypincodestextarea = [];
      //var pincode = document.getElementById("textareapincodes");
      //pincode.classList.remove("text-danger");
      document.getElementById("pincodemsg").innerHTML = "";
      document.getElementById("pincodemsg").style.display = "none";
      this.errors.clear("form-2");
    },
    ClosePickupAllocateModal: function() {
      this.customer = {};
      this.pickupallocatetoggleInfo = !this.pickupallocatetoggleInfo;
    },
    clearPickupPincode: function() {
      //document.getElementById("textareapincodes1").value = "";
      this.customer.pickuppincodestextarea = [];
      //var pincode = document.getElementById("textareapincodes1");
      //pincode.classList.remove("text-danger");
      document.getElementById("pincodemsg1").innerHTML = "";
      document.getElementById("pincodemsg1").style.display = "none";
      this.errors.clear("form-3");
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.changeAgentPassword();
        }
      });
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updateDeliveryAgent();
        }
      });
    },
    changeAgentPassword: function() {
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        deliveryagentpassword: `${this.customer.deliveryagentpassword}`,
        lastmodifiedby: `${userInfo.sysemailid}`
      };
      if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/changepassword`,
            passwObj
          )
          .then(result => {
            alert("Password Updated Successfully");
            // this.$fire({
            //       text: "Password Updated Successfully",
            //       type: "success",
            //       timer: 300000
            //     });
            // this.$alert("Hello Vue Simple Alert.");
            this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
            this.customer = {};
            this.displaydata();
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    },
      agentlogcancel: function() {
      this.customer = {};

     this.showdeliveryagentlogmodal = !this.showdeliveryagentlogmodal;
    },
    cancel:function() {
      this.customer = {};
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },
    pickcancel:function() {
      this.customer = {};
      this.pickupLocationModal = !this.pickupLocationModal;
    },
     
    editcancel: function() {
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
    },
     editinfoModal: function(value) {
      // alert(value.relieving_rider);
      // console.log('test ');
      // alert(value.vehicleno);      
      //  console.log('test ');
      var str = value.vehicleno;
      var res = str.split(/(\s+)/)
      var res = str.split(' ')
            // alert(res);
        // alert(res[0]);
        
        // alert(res[2]);
        // alert(res.length)
 

if(res.length >=2)
{
  var prefix =res[0];
  var vehicl_no= res[1]
}
else
{
 var prefix ="";
  var vehicl_no= res[0]
}

      this.customer.deliveryagentfirstname =value.deliveryagentfirstname;
      this.customer.deliveryagentlastname =value.deliveryagentlastname;
      this.customer.editmobilenumber = value.deliveryagentmobilenumber;
      this.customer.editvehicleno =vehicl_no;
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.editusertype = value.usertype; 
      this.customer.editfmridertype = value.relieving_rider;
      this.customer.isprivilage = value.privilege_rider;
      this.customer.local = value.local; 
      this.customer.mobile_no=value.deliveryagentmobilenumber;
      this.customer.altmobile_no=value.deliveryagentaltmobilenumber;
      this.customer.vehicleno_prefix = prefix; 
      this.customer.vehicle_city = value.vehicle_city; 
      this.customer.vehicle_country = value.vehicle_country; 
      this.customer.driving_license = value.driving_license;
      this.customer.driver_contracter_name = value.driver_contracter_name;
      this.customer.contracter_emailid = value.contracter_emailid;
      this.customer.is_dummy = value.is_dummy;
      this.customer.ivr_rider = value.ivr_rider;
      this.customer.is_sdd_ndd = value.sdd_ndd_type;
      // console.log("Issddndd",this.customer.is_sdd_ndd);
      this.customer.lastmodifiedby = value.lastmodifiedby; 
      if(this.customer.editusertype=='3'|| this.customer.editfmridertype==null) {
        this.display_value=false;
      }else{
         this.display_value=true;
      }
      this.editAgentMaster = !this.editAgentMaster;
     
    },
//     editinfoModal: function(value) {
//       // console.log('test ');
//       // console.log(value);      
//       //  console.log('test ');
//       var str = value.vehicleno;
//       var res = str.split(/(\s+)/)
//       if(res.length >=2)
// {
//   var prefix =res[0];
//   var vehicl_no= res[1]
// }
// else
// {
//  var prefix ="";
//   var vehicl_no= res[0]
// }
     
//       this.customer.deliveryagentfirstname =value.deliveryagentfirstname;
//       this.customer.deliveryagentlastname =value.deliveryagentlastname;
//       this.customer.editmobilenumber = value.deliveryagentmobilenumber;
//       this.customer.editvehicleno = vehicl_no;
//       this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
//       this.customer.editusertype = value.usertype; 
//       this.customer.local = value.local; 
//       this.customer.mobile_no=value.deliveryagentmobilenumber;
//       this.customer.vehicleno_prefix =prefix;  
//       this.customer.vehicle_city = value.vehicle_city; 
//       this.customer.vehicle_country = value.vehicle_country; 
//       this.customer.driving_license = value.driving_license;
//       this.customer.driver_contracter_name = value.driver_contracter_name;
//       this.customer.contracter_emailid = value.contracter_emailid;
//       this.customer.is_dummy = value.is_dummy;
//       this.customer.lastmodifiedby = value.lastmodifiedby;     
//       this.editAgentMaster = !this.editAgentMaster;
  
//     },



    //  updateDeliveryAgent: function() {      
    //   var result = [];
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //    var vehicleno1=this.customer.vehicleno_prefix+' '+this.customer.editvehicleno
    //   var editusertype='0';
    //   if(this.customer.editusertype){
    //     editusertype=this.customer.editusertype;
    //   }
    //   var passwObj = {
    //     deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
    //     vehicleno:vehicleno1,
    //     lastmodifiedby: `${userInfo.sysemailid}`,
    //     usertype:editusertype,
    //     local:`${this.customer.local}`,
    //     deliveryagentmobilenumber:`${this.customer.mobile_no}`,
    //     vehicleno_prefix:`${this.customer.vehicleno_prefix}`,
    //     vehicle_city:`${this.customer.vehicle_city}`,
    //     vehicle_country:`${this.customer.vehicle_country}`,
    //     driving_license:`${this.customer.driving_license}`,
    //     driver_contracter_name:`${this.customer.driver_contracter_name}`,
    //     contracter_emailid:`${this.customer.contracter_emailid}`,
    //     is_dummy:`${this.customer.is_dummy}`

    //   };  
    //   if (typeof this.customer.deliveryagentmasterid !== "undefined") {
    //     //DAUpdateVehicleDetail
    //     this.$http
    //       .post(
    //         `${CONSTANTS.MIGRATION_API_URL}/daupdatevehicledetails`,
    //         passwObj
    //       ).then(result => {
    //        if (result.body.returnmsg === "Successful") {
    //         alert("updated successfully");
    //         this.editAgentMaster = !this.editAgentMaster;
    //         this.customer = {};
    //         this.displaydata();
    //       }
    //       else
    //       {
    //         Utils.notify(result.body.returnvalue, "error");
    //        // alert(result.body.returnvalue);
    //       }
    //       })
    //       .catch(ex => {
    //         console.log("error", ex);
    //       });
    //   }
    // },  
    // updateDeliveryAgent: function() {  
    // console.log(this.customer.vehicleprefix);    
    //   var result = [];
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //    //var vehicleno1=this.customer.vehicleno_prefix+' '+this.customer.editvehicleno
    //   var editusertype='0';

    //   if(this.customer.editusertype){
    //     editusertype=this.customer.editusertype;
    //   }
       
    //    if(this.customer.vehicleprefix == undefined||this.customer.vehicleprefix == null ||this.customer.vehicleprefix == '')
    //   {
    //    var vehicleno1=this.customer.editvehicleno
    //   }
    //   else
    //   {
    //      var vehicleno1=this.customer.vehicleno_prefix+' '+this.customer.editvehicleno
       
    //   }
    //   var passwObj = {
    //     deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
    //     vehicleno:vehicleno1,
    //     lastmodifiedby: `${userInfo.sysemailid}`,
    //     usertype:editusertype,
    //     local:`${this.customer.local}`,
    //     deliveryagentmobilenumber:`${this.customer.mobile_no}`,
    //     vehicleno_prefix:`${this.customer.vehicleno_prefix}`,
    //     vehicle_city:`${this.customer.vehicle_city}`,
    //     vehicle_country:`${this.customer.vehicle_country}`,
    //     driving_license:`${this.customer.driving_license}`,
    //     driver_contracter_name:`${this.customer.driver_contracter_name}`,
    //     contracter_emailid:`${this.customer.contracter_emailid}`,
    //     is_dummy:`${this.customer.is_dummy}`

    //   };  
    //   if (typeof this.customer.deliveryagentmasterid !== "undefined") {
    //     //DAUpdateVehicleDetail
    //     this.$http
    //       .post(
    //         `${CONSTANTS.MIGRATION_API_URL}/daupdatevehicledetails`,
    //         passwObj
    //       ).then(result => {
    //        if (result.body.returnmsg === "Successful") {
    //         alert("updated successfully");
    //         this.editAgentMaster = !this.editAgentMaster;
    //         this.customer = {};
    //         this.displaydata();
    //       }
    //       else
    //       {
    //         Utils.notify(result.body.returnvalue, "error");
    //        // alert(result.body.returnvalue);
    //       }
    //       })
    //       .catch(ex => {
    //         console.log("error", ex);
    //       });
    //   }
    // }, 
    updateDeliveryAgent: function() {      
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
       
      var editusertype='0';
       var editfmridertype='';
      if(this.customer.editusertype){
        editusertype=this.customer.editusertype;
      }
       if(this.customer.editfmridertype){
        editfmridertype=this.customer.editfmridertype;
      }
      if(this.customer.vehicleno_prefix == undefined||this.customer.vehicleno_prefix == null ||this.customer.vehicleno_prefix == '')
      {
       var vehicleno1=this.customer.editvehicleno
      }
      else
      {
         var vehicleno1=this.customer.vehicleno_prefix+' '+this.customer.editvehicleno
       
      }
       if(this.customer.altmobile_no == this.customer.mobile_no )  
                {
                  alert("Alternate Mobile Number should be different from Mobile Number");
                //      this.$fire({
                //   text: "Alternate Mobile Number should be different from Mobile Number",
                //   type: "warning",
                //   timer: 30000
                // });
                  return false;
                }
       if(editusertype=='4'){
          // alert(editusertype)
                var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        vehicleno:vehicleno1,
        lastmodifiedby: `${userInfo.sysemailid}`,
        usertype:editusertype,
         relieving_rider:this.customer.editfmridertype,
        privilege_rider:`${this.customer.isprivilage}`,
        local:`${this.customer.local}`,
        deliveryagentmobilenumber:`${this.customer.mobile_no}`,
        deliveryagentaltmobilenumber:`${this.customer.altmobile_no}`,
        vehicleno_prefix:`${this.customer.vehicleno_prefix}`,
        vehicle_city:`${this.customer.vehicle_city}`,
        vehicle_country:`${this.customer.vehicle_country}`,
        driving_license:`${this.customer.driving_license}`,
        driver_contracter_name:`${this.customer.driver_contracter_name}`,
        contracter_emailid:`${this.customer.contracter_emailid}`,
        is_dummy:`${this.customer.is_dummy}`,
        ivr_rider:`${this.customer.ivr_rider}`,
        is_sdd_ndd:`${this.customer.is_sdd_ndd}`,

      };  
      // console.log("Hiiii",passwObj);
      if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        //DAUpdateVehicleDetail
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/daupdatevehicledetails`,
            passwObj
          ).then(result => {  
           if (result.body.returnmsg === "Successful") {
            alert("Updated Successfully");
             // this.$fire({
             //      text: "Updated Successfully",
             //      type: "success",
             //      timer: 30000
             //    });
            this.editAgentMaster = !this.editAgentMaster;
            this.customer = {};
            this.displaydata();
          }
          else
          {
            // Utils.notify(result.body.returnvalue, "error");
           alert(result.body.returnvalue);
           // this.$alert(result.body.returnvalue);
           // this.$fire({
           //        text: result.body.returnvalue,
           //        type: "error",
           //        timer: 300000
           //      });
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    }
      else{
     
      var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        vehicleno:vehicleno1,
        lastmodifiedby: `${userInfo.sysemailid}`,
        usertype:editusertype,
         // relieving_rider:editfmridertype,
        privilege_rider:`${this.customer.isprivilage}`,
        local:`${this.customer.local}`,
        deliveryagentmobilenumber:`${this.customer.mobile_no}`,
        deliveryagentaltmobilenumber:`${this.customer.altmobile_no}`,
        vehicleno_prefix:`${this.customer.vehicleno_prefix}`,
        vehicle_city:`${this.customer.vehicle_city}`,
        vehicle_country:`${this.customer.vehicle_country}`,
        driving_license:`${this.customer.driving_license}`,
        driver_contracter_name:`${this.customer.driver_contracter_name}`,
        contracter_emailid:`${this.customer.contracter_emailid}`,
        is_dummy:`${this.customer.is_dummy}`,
        ivr_rider:`${this.customer.ivr_rider}`,
        is_sdd_ndd:`${this.customer.is_sdd_ndd}`,

      };  
      // console.log("Hiiii",passwObj);
      if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        //DAUpdateVehicleDetail
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/daupdatevehicledetails`,
            passwObj
          ).then(result => {  
           if (result.body.returnmsg === "Successful") {
            alert("Updated Successfully");
             // this.$fire({
             //      text: "Updated Successfully",
             //      type: "success",
             //      timer: 30000
             //    });
            this.editAgentMaster = !this.editAgentMaster;
            this.customer = {};
            this.displaydata();
          }
          else
          {
            // Utils.notify(result.body.returnvalue, "error");
           alert(result.body.returnvalue);
           // this.$alert(result.body.returnvalue);
           // this.$fire({
           //        text: result.body.returnvalue,
           //        type: "error",
           //        timer: 300000
           //      });
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    }
    }, 
    toggleInfoModal: function(value) {    
      //debugger
      this.customer = value;
      if (value.isactive === "1") {
         
        //this.customer.isactive = true
      } else {
         
         if(!value.deliveryagentmobilenumber)
        {
        alert("To Active The User Plz Update Mobile Number & Vehicle No.");  
         // this.$fire({
         //          text: "To Active The User Plz Update Mobile Number & Vehicle No.",
         //          type: "warning",
         //          timer: 30000
         //        }); 

        this.toggleInfo = !this.toggleInfo;
      }
        //this.customer.isactive = false
      }
      if (typeof value !== "undefined") {
        document.getElementById("deliveryagentmasterId").value =
          value.deliveryagentmasterid;
        document.getElementById("isactiveId").value = value.isactive;
      }
      this.toggleInfo = !this.toggleInfo;
    },
    isJson: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    validateForm3(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.searchResults1=[];
          this.AllocatePickupPincodes();
        }
      });
    },
    AllocatePickupPincodes: function() {
      var result = [];
      //var validateflag = this.validatePickupPincodes();
      //if (validateflag) {
        //this.validatePickupPincodes();
        var pickuppin = this.customer.pickuppincodestextarea;
        var pickup = pickuppin;
        var a = pickup.indexOf(`${this.customer.deliveryagentpincode}`);
        if (a === -1) {
          pickup.push(`${this.customer.deliveryagentpincode}`);
        }
        // var dupArray = this.getDuplicateValue(pickup);
        // if (dupArray.length > 0) {
        //   Utils.notify("Duplicate pickup pincode - " + dupArray, "error");
        //   return true;
        // }
        for (var r = 0; r < pickup.length; r++) {
          var pickuppins = pickup[r].toString();
          if (pickuppins !== "") {
            const pincodeObj = {
              pickuppincode: pickuppins
            };
            result.push(pincodeObj);
          }
        }
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var deliveryObj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
          pincodes: JSON.stringify(result),
          lastmodifiedby: `${userInfo.sysemailid}`
        };
        if (typeof this.customer.deliveryagentmasterid !== "undefined") {
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/allocatepickuppincodes`, deliveryObj)
            .then(result => {
             Utils.notify("Added Successfully", "success");
              // this.$fire({
              //     text: "Added Successfully",
              //     type: "success",
              //     timer: 30000
              //   }); 

              this.customer.pickuppincodestextarea = [];
              //document.getElementById("textareapincodes1").value = "";
              this.displaydata();
              this.pickupLocationModal = !this.pickupLocationModal;
              this.customer = {};
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          
          alert("Please Allocate Delivery Agent Master Id");
            // this.$fire({
            //       text: "Please Allocate Delivery Agent Master Id",
            //       type: "warning",
            //       timer: 30000
            //     }); 

        }
      //   var passwObj = {
      //     deliveryagentid: `${this.customer.deliveryagentmasterid}`
          
      //   };
      // this.$http
      //   .post(`${CONSTANTS.MIGRATION_API_URL}/getdeliveryandpickuppincodes`,passwObj)
      //   .then(result => {
          
      //     this.pindata = result.body;
          
      //   })
      //   .catch(ex => {
      //     alert(ex);
      //   });
    
      //}
    },
   
    editAgentMasterModal: function(value) {
      this.customer.deliveryagentpassword = value.deliveryagentpassword;
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },    
    addAllowedAllocations: function(deliveryagentmasterid) {
      var inputnumber = document.getElementById(
        "totalAllocationsAllowedCls_" + deliveryagentmasterid
      ).value;
      if (isNaN(inputnumber) || inputnumber === "") {
        document.getElementById("msg" + deliveryagentmasterid).style.color =
          "red";
        document.getElementById("msg" + deliveryagentmasterid).innerHTML =
          " You need to enter a number";
        document.getElementById("msg" + deliveryagentmasterid).style.display =
          "block";
        return false;
      }
      inputnumber = Number(inputnumber);
      if (inputnumber < 0) {
        document.getElementById("msg" + deliveryagentmasterid).style.color =
          "red";
        document.getElementById("msg" + deliveryagentmasterid).innerHTML =
          "You need to enter a positive number";
        document.getElementById("msg" + deliveryagentmasterid).style.display =
          "block";
        return false;
      }
      document.getElementById("msg" + deliveryagentmasterid).innerHTML = "";
      document.getElementById("msg" + deliveryagentmasterid).style.display =
        "none";
      var totalallocations = document.getElementById(
        "totalAllocationsAllowedCls_" + deliveryagentmasterid
      ).value;
      if (totalallocations === "" || totalallocations < 0) {
        totalallocations = 0;
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        deliveryagentmasterid: `${deliveryagentmasterid}`,
        totalallocationallowed: totalallocations,
        lastmodifiedby: `${userInfo.pickuplocationmasterid}`
      };
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/updatetotalallocationallowed`,
          customerGetobj
        )
        .then(result => {
          if (result.body[0].returnmsg === "successful") {
           Utils.notify("Total Allocation Added Successfully", "success");
            // this.$fire({
            //       text: "Total Allocation Added Successfully",
            //       type: "success",
            //       timer: 30000
            //     }); 
            document.getElementById(
              "totalAllocationsAllowedCls_" + deliveryagentmasterid
            ).value = totalallocations;
            document.getElementById(
              "totalAllocationsAllowedClsapen_" + deliveryagentmasterid
            ).innerHTML = totalallocations;
             // this.reloadPage();
          } else {
            Utils.notify(result.body.returnmsg, "error");
             // this.$fire({
             //      text: result.body.returnmsg,
             //      type: "error",
             //      timer: 30000
             //    }); 
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    },
     activateInActivateDeliveryAgent: function(value) {
      var deliveryagentmasterId = document.getElementById(
        "deliveryagentmasterId"
      ).value;
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
        // console.log("activeInactiveVal",activeInactiveVal);
      } else {
        activeInactiveVal = "1";
        // console.log("activeInactiveVal1",activeInactiveVal);
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        deliveryagentmasterid: deliveryagentmasterId,
        isactive: activeInactiveVal,
        lastmodifiedby: `${userInfo.sysemailid}`
      };

      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/activateinactivatedeliveryagent`,
          customerGetobj
        )
        .then(result => {
          // console.log("result",result);
          if(result.body.returnmsg ==="Unsuccessful")
          {
             alert("Shipments are Allocated so can not InActive");
              // this.$fire({
              //     text: "Shipments are Allocated so can not InActive",
              //     type: "error",
              //     timer: 30000
              //   }); 

              this.toggleInfo = false;
         //this.displaydata();
         
        }
        else
        {
        alert("Status Changed Successfully");
        // this.$fire({
        //           text: "Status Changed Successfully",
        //           type: "success",
        //           timer: 30000
        //         }); 
          this.toggleInfo = false;
          this.displaydata();
        }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    //  this.displaydata();
     // alert("Status changed successfully");
    },
    // activateInActivateDeliveryAgent: function(value) {
    //   var deliveryagentmasterId = document.getElementById(
    //     "deliveryagentmasterId"
    //   ).value;
    //   var activeInactiveVal;
    //   if (this.customer.isactive === "1") {
    //     activeInactiveVal = "0";
    //   } else {
    //     activeInactiveVal = "1";
    //   }
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //   const customerGetobj = {
    //     deliveryagentmasterid: deliveryagentmasterId,
    //     isactive: activeInactiveVal,
    //     lastmodifiedby: `${userInfo.sysemailid}`
    //   };
    //   this.$http
    //     .post(
    //       `${CONSTANTS.API_URL}/ActivateInActivateDeliveryAgent`,
    //       customerGetobj
    //     )
    //     .then(result => {
    //       this.toggleInfo = false;
    //       this.displaydata();
    //       //location.reload()
    //     })
    //     .catch(ex => {
    //       console.log("error", ex);
    //     });
    // //  this.displaydata();
    //   alert("Status changed successfully");
    // },
    // pallet shipmentlist
    getAllPalletShipmentsListByStatus:function(type,button){
      this.showPallet=true;
     const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallpalletlistforrider`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.returnmsg === "Successful") {
            this.palletshipment=results.body.returnvalue;
           // console.log("view Shipment",this.palletshipment);
          // this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.palletshipment =[];
           // this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });

    },

 // function for regular and warrenty count
 forwardpickup_reg_war:function(type,button,status){
 if(type.cnt==0){
  // alert('No Any Shipments For '+type.name);
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.forwardpickup_countmodel=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
 },
reversepickupcount:function(loc_id,button,status){
        // if(type.cnt==0){
  // alert('No Any Shipments For '+type.name);
        // Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      // }else{
        this.selected_locid=loc_id;
        // console.log("kkkkkkk", this.selected_locid);
        this.reversepickup_countmodel=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
            locality_id:loc_id,

          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
          // }

},
ofd_count:function(button,loc_id,status,){

        this.selected_locid=loc_id;
        // console.log("kkkkkkk", this.selected_locid);
        this.ofd_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
            locality_id:loc_id,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

},
rofd_count:function(loc_id,status){

        this.selected_locid=loc_id;
        // console.log("kkkkkkk", this.selected_locid);
        this.rofd_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
            locality_id:loc_id,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

},
transit_count:function(type,button,status){
if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.transit_count_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
},
handoverpending_count:function(type,button,status){
  if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.handoverpending_count_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
    },
totaldelivered_count:function(type,button,status){
  if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.totaldelivered_count_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
    },
    failedpickup_count:function(type,button,status){
  if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.failedpickup_count_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
    },
  clientpickcancel_count:function(type,button,status){
  if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        this.selected_cnt=type.cnt;
        this.selected_name=type.name;
        this.selected_pagetype=type.pageType;
        console.log("kkkkkkk",type);
        this.clientpickcancel_count_model=true;
            const obj = {
            deliveryagentmasterid:this.deliveryboyId,
            shipmentstatus:status,
          }
          console.log("mmmmmm",obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdapendingbyagentforregularandwarranty`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                // alert("jjj")
              this.shipmentcount=result.body.returnvalue;
              console.log("yyyy",this.shipmentcount);
              // this.warrantyshipmentcount=result.body.returnvalue.warrantyshipmentcount;
              // console.log("uuu", this.warrantyshipmentcount);
              } 
              else {
                
             this.shipmentcount={
                 regularshipmentcount:0,
                 warrantyshipmentcount:0,
              }
                   // document.getElementById("overlay").style.display = "none";
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

      }
    },
    getAllShipmentsListByStatus:function(button,iswarranty,shipment){
     // alert(shipment)
      if(shipment==0){
        alert('No Shipments For '+this.selected_name);
        // Utils.notify('No Shipments For '+this.selected_name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        // alert("in");
        this.allshipmentsbystatus.title=this.deliveryboyName +' - '+this.selected_name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:this.selected_pagetype,
        iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus_modified`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.message.toLowerCase() === "success") {

           this.allshipmentsbystatus.data =results.body.data.shipment_list;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },

    getAllShipmentsListByStatusfortransit:function(button,iswarranty,shipment){
      // alert("in");
     
      if(shipment==0){
        alert('No Shipments For '+ this.selected_name)
        // Utils.notify('No Shipments For '+this.selected_name, "error");
           // this.$fire({
           //        text: "No Any shipments For "+type.name,
           //        type: "error",
           //        timer: 30000
           //      }); 
      }else{
        // alert("in");
        this.allshipmentsbystatus.title=this.deliveryboyName +' - '+this.selected_name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:this.selected_pagetype,
        iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus_modified`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.message.toLowerCase() === "success") {

           this.allshipmentsbystatus.data =results.body.data.shipment_list;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },
   setcountry: function(event) {
     //alert("mukesh");
      // console.log(event);
      if(event=="yes")
      {
        //alert("yes");
       this.customer.vehicle_country="United Arab Emirates" 
      }
      else
       {
        //alert("No");
        this.customer.vehicle_country=""
       } 
    },


    getAllShipmentsListByStatus3PL:function(type,button){
      
      if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
         // this.$fire({
         //          text: "No Any shipments For "+type.name,
         //          type: "error",
         //          timer: 30000
         //        }); 
      }else{
        this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:type.pageType
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus3PL_modified`,
          agentObj
        ).then(results => {
          // console.log(results);
           if (results.body.message.toLowerCase() === "success") {
           this.allshipmentsbystatus.data =results.body.data.shipment_list;
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },



    getconsignmentPickUpPendingList:function(type,button){
      console.log("Shipmentttts",type);
   
      if(type.cnt==0){
        Utils.notify('No Any Shipments For '+type.name, "error");
         // this.$fire({
         //          text: "No Any shipments For "+type.name,
         //          type: "error",
         //          timer: 30000
         //        }); 
      }else{
        this.consignmentPickUpPendingList.title=type.orderflow.toUpperCase()+' Pickup';
        const agentObj = {
        id:`${this.deliveryboyId}`,
        pickuplocationmasterid:`${type.pickuplocationmasterid}`,
        mobilenumber:this.deliveryboyMb,
        orderflow:type.orderflow,
        iswarrantyshipment:`${type.iswarrantyshipment}`,
        };

         
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getconsignmentpickuppendinglist`,
          agentObj
        ).then(results => {
          // console.log('=======================');
          // console.log(results.data);
          // console.log('=======================');
           this.consignmentPickUpPendingList.title=type.orderflow.toUpperCase()+' Pickup('+ results.body.pendingshipments.length+')';
           this.consignmentPickUpPendingList.content=type;
           this.consignmentPickUpPendingList.data =results.body.pendingshipments;
           this.$root.$emit('bv::show::modal', this.consignmentPickUpPendingList.id, button)
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },
    // Nazaft Addition
    showpalletdetails:function(button,pallet){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
       const agentObj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
        // shipmentstatus:"ofd",
        pallet_id:pallet
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getpalletshipmentlist`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.returnmsg === "Successful") {

           this.allshipmentsbystatus.data =results.body.returnvalue;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
    },
     // Function For Reversecount
    reversecountdetails:function(loc_id){
      // alert("reversecountdetails")
         const reverseObj={
          locality_id:loc_id
        };
              this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getshipmentdetailsforreversebookingpending`,
          reverseObj
        ).then(results => {
          // console.log("Result",results);         
            // alert("in");
          this.showReversecount=true;
          this.reversecountdetail=results.body.returnvalue;
          // console.log("Reverse Count",this.reversecountdetail);
            
        }).catch(ex => {
          // alert("else");
          console.log("error", ex);
        });

    },

    // functionend

    showlocalitydetails:function(button,status,shipment,iswarranty){
      //  if(type.cnt==0){
      //   Utils.notify('No Any shipments For '+type.name, "error");
      // }else{
        // this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:status,
        locality_id:this.selected_locid,
        iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus_modified`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.message.toLowerCase() === "success") {

           this.allshipmentsbystatus.data =results.body.data.shipment_list;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
    },

    showRofdlocalitydetails:function(button,status,shipment,iswarranty){
      //  if(type.cnt==0){
      //   Utils.notify('No Any shipments For '+type.name, "error");
      // }else{
        // this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:status,
        locality_id:this.selected_locid,
        iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus_modified`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.message.toLowerCase() === "success") {

           this.allshipmentsbystatus.data =results.body.data.shipment_list;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
    },
    // Reverse Pickup
    showReversepickupdetails:function(button,status,shipment,iswarranty){
      // this.selected_locid=loc_id;
      //  if(type.cnt==0){
      //   Utils.notify('No Any shipments For '+type.name, "error");
      // }else{
        // this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:status,
        locality_id:this.selected_locid,
        iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getallshipmentslistbystatus_modified`,
          agentObj
        ).then(results => {
          // console.log("Result",results);
           if (results.body.message.toLowerCase() === "success") {

           this.allshipmentsbystatus.data =results.body.data.shipment_list;
           // console.log("view Shipment",this.allshipmentsbystatus.data);
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
    },
    // localityReverse:function(button,status,shipment,iswarranty
    localityReverse:function(type,status){

      // this.selected_iswarranty=iswarranty;
      // console.log("jjjjj",this.selected_iswarranty);
       // if(shipment==0){
        // alert('No Any Shipments For Reverse');
      // }else{
      // this.selected_locid=loc_id;
      // alert("in");
       const Obj = {
        deliveryagentmasterid:this.selected_rider,
        shipmentstatus:status,
        sdd_ndd_type:this.sddndd_type,
        // iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/localitywisecount`,
          Obj
        ).then(results => {
          // console.log("TTTTTTTTTTTTTTTTTTT",results.body.returnmsg);
          if (results.body.message.toLowerCase() === "success"){
            this.showReverse=true;
             // this.data1 = results.body.data.shipment_list;
            
              // this.items1  = results.body.data.shipment_list;
               // console.log("ggggg", this.item1);
          // console.log("Hello",results.body.data.shipment_list[0]);
          this.reverse_listing=results.body.data.shipment_list;
          this.ofdlistinginfo.data=results.body.data.shipment_list;
            // console.log("ofdlistinginfo",this.ofdlistinginfo.data);
            // console.log("TTTTTTTTTTTTTTTTTTT",this.reverse_listing);
          this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id)
          }else{
            this.allshipmentsbystatus.data =[];
           // this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id,)
         }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
    },
    // Rofd code
    localityRofd:function(status){
      // this.selected_iswarranty=iswarranty;
       // if(shipment==0){
      //   alert('No Any Shipments For ROFD');
      // }else{
       const Obj = {
        deliveryagentmasterid:this.selected_rider,
        shipmentstatus:status,
        sdd_ndd_type:this.sddndd_type,
        // iswarrantyshipment:iswarranty
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/localitywisecount`,
          Obj
        ).then(results => {
          // console.log("TTTTTTTTTTTTTTTTTTT",results.body.returnmsg);
          if (results.body.message.toLowerCase() === "success"){
            this.showRofd=true;
             // this.data1 = results.body.data.shipment_list;
            
              // this.items1  = results.body.data.shipment_list;
               // console.log("ggggg", this.item1);
          // console.log("Hello",results.body.data.shipment_list[0]);
          this.rofd_listing=results.body.data.shipment_list;
          this.ofdlistinginfo.data=results.body.data.shipment_list;
            // console.log("ofdlistinginfo",this.ofdlistinginfo.data);
            // console.log("TTTTTTTTTTTTTTTTTTT",this.rofd_listing);
          this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id)
          }else{
            this.allshipmentsbystatus.data =[];
           // this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id,)
         }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
    },
    localityOfd:function(status){
      // this.selected_iswarranty=iswarranty;
      // alert(shipment);
      // if(shipment==0){
      //   alert('No Any Shipments For OFD');
      // }else{
      // alert("ofd");
        const Obj = {
        deliveryagentmasterid:this.selected_rider,
        shipmentstatus:status,
        sdd_ndd_type:this.sddndd_type,
         // iswarrantyshipment:iswarranty,
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/localitywisecount`,
          Obj
        ).then(results => {
          // console.log("TTTTTTTTTTTTTTTTTTT",results.body.returnmsg);
          // console.log("result",results);
          if (results.body.message.toLowerCase() === "success"){
            this.showOfd=true;
             // this.data1 = results.body.data.shipment_list;
            
              // this.items1  = results.body.data.shipment_list;
               // console.log("ggggg", this.item1);
          // console.log("Hello",results.body.data.shipment_list[0]);
          this.ofd_listing=results.body.data.shipment_list;
          this.ofdlistinginfo.data=results.body.data.shipment_list;
            // console.log("ofdlistinginfo",this.ofdlistinginfo.data);
            // console.log("TTTTTTTTTTTTTTTTTTT",this.ofd_listing);
          this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id)
          }else{
            this.allshipmentsbystatus.data =[];
           // this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id,)
         }
        }).catch(ex => {
          console.log("error", ex);
        });
      // }
      },

// Nazaft Addition
  listingDashbord:function(){

      
      //   const Obj = {
      //   deliveryagentmasterid:607,
      //   shipmentstatus:'ofd'
      // };
      // this.$http.post(
      //     `${
      //       CONSTANTS.MIGRATION_API_URL
      //     }/localitywisecount`,
      //     Obj
      //   ).then(results => {
      //     if (results.body.message.toLowerCase() === "success"){
      //        this.data1 = results.body.data.shipment_list;
            
      //         this.items1  = results.body.data.shipment_list;
      //          console.log("ggggg", this.item1);
      //     // console.log("Hello",results.body.data.shipment_list[0]);
      //     this.ofd_listing=results.body.data.shipment_list;
      //     this.ofdlistinginfo.data=results.body.data.shipment_list;
      //       console.log("ofdlistinginfo",this.ofdlistinginfo.data);
      //     this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id)
      //     }else{
      //       this.allshipmentsbystatus.data =[];
      //      this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id,)
      //    }
      //   }).catch(ex => {
      //     console.log("error", ex);
      //   });
      // this.deliveryboyId=item.deliveryagentmasterid;
      // this.deliveryboyName=item.deliveryagentfirstname+' '+ item.deliveryagentlastname;
      // this.deliveryboyMb=item.deliveryagentmobilenumber;
      // this.ofdlistinginfo.title = `Dashbord Info: ${item.deliveryagentfirstname.toUpperCase()} ${item.deliveryagentlastname.toUpperCase()}`; 
      // this.ofdlistinginfo.content = JSON.stringify(item, null, 2);
      const agentObj = {
        deliveryagentmasterid:  607
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getalldapendingbyagent`,
          agentObj
        ).then(results => {
           if (results.body.returnmsg.toLowerCase() === "successful") {
         // dashboardinfoSuccessful
         this.ofdlistinginfo.data =results.body.returnvalue;
         // console.log("ofdddddddddddddddddddd",this.ofdlistinginfo.data);
          // this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id)
              
              this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getalldapendingbyagent3PL`,
          agentObj
        ).then(results => {
          
         
         this.ofdlistinginfo3pl.data =results.body.returnvalue;
         
          
          }).catch(ex => {
          console.log("error", ex);
        });
          this.showOfd=true;
          }
          else{
            //alert("teting else");
            this.ofdlistinginfo3pl.data =0;
           this.$root.$emit('bv::show::modal', this.ofdlistinginfo.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
     },


// Nazaft Addition

    deliveryDashbord:function(item, index, button){
      // console.log("hii",item);
      this.selected_rider=item.deliveryagentmasterid;
      this.deliveryboyId=item.deliveryagentmasterid;
      this.deliveryboyName=item.deliveryagentfirstname+' '+ item.deliveryagentlastname;
      this.sddndd_type=item.sdd_ndd_type;
      this.deliveryboyMb=item.deliveryagentmobilenumber;
      this.dashboardinfo.title = `Dashbord Info: ${item.deliveryagentfirstname.toUpperCase()} ${item.deliveryagentlastname.toUpperCase()}`; 
      this.dashboardinfo.content = JSON.stringify(item, null, 2);
      const agentObj = {
        deliveryagentmasterid: item.deliveryagentmasterid
      };
      this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getalldapendingbyagent`,
          agentObj
        ).then(results => {
           if (results.body.returnmsg.toLowerCase() === "successful") {
         // dashboardinfoSuccessful
         this.dashboardinfo.data =results.body.returnvalue;
         // console.log("EEEEEEEEEEEEEEEEEEEEEEEEE",this.dashboardinfo.data[1].data[1].cnt)
          this.$root.$emit('bv::show::modal', this.dashboardinfo.id, button)
              
              this.$http.post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getalldapendingbyagent3PL`,
          agentObj
        ).then(results => {
          
         
         this.dashboardinfo3pl.data =results.body.returnvalue;
         
          
          }).catch(ex => {
          console.log("error", ex);
        });
        
          }
          else{
            //alert("teting else");
            this.dashboardinfo3pl.data =0;
           this.$root.$emit('bv::show::modal', this.dashboardinfo.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
     },

   
    addAgentInfo: function() {
      var chkmobileVal = this.chkmobileVal();
      if (chkmobileVal) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (this.customer.isactive === "1") {
          this.customer.isactive = "1";
        } else {
          this.customer.isactive = "0";
        }
        this.customer.isverified = "1";
        this.customer.lastmodifiedby = `${userInfo.sysemailid}`;
        this.customer.deliveryagentpincode = `${
          userInfo.pickuplocationpincode
        }`;

        this.$validator.validateAll().then(result => {
          if (result) {
            this.$http
              .post(
                `${
                  CONSTANTS.MIGRATION_API_URL
                }/deliveryagentsignuphub`,
                this.customer
              )
              .then(results => {
              // console.log(results.body[0].returnmsg)
                if (results.body[0].returnmsg === "Successful") {
                  Utils.notify("Added Successfully", "success");
                //    this.$fire({
                //   text: "Added Successfully",
                //   type: "success",
                //   timer: 30000
                // }); 

                  this.customer = {};
                  this.displaydata();
                   var adduser = document.getElementById("adduser");
                   adduser.style.display = "none";
                   this.$router.push('/deliveryagentmaster');
                } else {
                  alert(results.body[0].returnvalue);
                  // this.$alert(results.body[0].returnvalue);
                //   this.$fire({
                //   text: results.body[0].returnvalue,
                //   type: "error",
                //   timer: 30000
                // }); 
                 // Utils.notify(results.body[0].returnvalue, "error");
                }
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
            // this.$fire({
            //       text: "Correct Them",
            //       type: "error",
            //       timer: 30000
            //     }); 
          }
        });
      } else {
        Utils.notify("Please Enter Valid Mobile Number", "error");
         // this.$fire({
         //          text: "Please Enter Valid Mobile Number",
         //          type: "error",
         //          timer: 30000
         //        }); 
      }
    },
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    },
    capitalize: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-scrollbar {
position: relative;
height: 200px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
}
.racktd{
  text-align: center;
  font-weight: bold;
}
.table button {
    background: #b0c4de !important;
    color: #000 !important;
}
#vendor_list_scroll{
    max-height: 500px;
    overflow-y: scroll;
  }
  #table{
     text-align: left;
  position: relative;
  border-collapse: collapse;
  }
  #th_style {
  background: #ECEFF1;
  position: sticky;
  top: 0; 
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

/*.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}*/
</style>
